<template>
  <div>

      <!--

      <v-select
          v-model="wasteno"
          :items="wasteno_list"
          outlined
          label="Abfallschlüssel"
          style="
          margin-left: 10px;
          width: 250px;"
      ></v-select>

      -->


    <v-row

    >

    <v-card

        style="
          width: 400px;
          margin: 20px;"
    >
      <v-card-title>Lagerbestand<br>zum Datum {{date}}</v-card-title>
      <v-card-text>

        <DialogDate
            v-bind:label="'Lagerbestand am'"
            v-bind:initial_date="date"
            v-bind:clearable="false"
            v-model="date"
            :key="date"
        ></DialogDate>
        <br>

        <v-row>
          <v-col cols="6">
            <v-text-field label="STARTWERT GUTREIFEN"
                          disabled
                          v-model="exportStartValueGood"
            ></v-text-field>
          </v-col>

  <v-col cols="6">
            <v-text-field label="STARTWERT SCHROTTREIFEN"
                          disabled
                          v-model="exportStartValueScrapped"
            ></v-text-field>
  </v-col>
        </v-row>

        <v-row>
          <v-col cols="6">
            <v-text-field label="STARTWERT STAHL"
                          disabled
                          v-model="exportStartValueSteel"
            ></v-text-field>
          </v-col>

  <v-col cols="6">
            <v-text-field label="STARTWERT ALU"
                          disabled
                          v-model="exportStartValueAlu"
            ></v-text-field>
  </v-col>
        </v-row>
        </v-center>

        <br>
        <b style="color: red;">Inventurwert + SUMME ab 01.01.{{ selected_year }}</b>
        <v-divider></v-divider>
        <br>

        <h2><b>{{total_weight_160103_good}}</b> Tonnen (Gutreifen/160103)</h2><br>
        <h2><b>{{total_weight_160103}}</b> Tonnen (Schrottreifen/160103)</h2><br>
        <h2><b>{{total_weight_160117}}</b> Tonnen (Stahl/160117)</h2><br>
        <h2><b>{{total_weight_160118}}</b> Tonnen (Alu/160118)</h2><br>

      </v-card-text>

        <br>

        <v-divider></v-divider>

    <!--    <div
        style="padding: 15px;"
        ></div>

       <div
          style="padding-left: 15px;"
      >
        <v-btn
        outlined
        @click="csvexport()"
        >CSV EXPORT</v-btn>
        </div>-->
        

        <!-- <div
            style="padding: 15px;">
        <v-btn
        outlined
        @click="testExport()"
        >stock EXPORT</v-btn>
    
        </div> -->
        
        <div style="padding: 15px;">
  <v-btn outlined @click="showExportDialog = true">Lager Export Details</v-btn>
  
  <v-dialog v-model="showExportDialog" max-width="600px">
    <v-card>
      <v-card-title>Lager Export Optionen</v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-select
                v-model="exportType"
                :items="exportTypes"
                label="Export Format"
                outlined
                dense
              ></v-select>
            </v-col>
            
            <v-col cols="12" sm="6">
              <DialogDate
                v-bind:label="'Start Datum'"
                v-model="startDate"
              ></DialogDate>
            </v-col>
            
            <v-col cols="12" sm="6">
              <DialogDate
                v-bind:label="'End Datum'"
                v-model="endDate"
              ></DialogDate>
            </v-col>

            
            <v-col cols="12">
              <v-divider></v-divider>
              <v-subheader>Startwerte (Inventur)</v-subheader>
            </v-col>

            <v-col cols="12" sm="6">
              <v-text-field
                v-model="exportStartValueGood"
                label="Startwert Gutreifen"
                type="number"
                step="0.001"
                outlined
                readonly
                dense
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="6">
              <v-text-field
                v-model="exportStartValueScrapped"
                label="Startwert Schrottreifen"
                type="number"
                step="0.001"
                outlined
                readonly
                dense
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="6">
              <v-text-field
                v-model="exportStartValueSteel"
                label="Startwert Stahlfelgen"
                type="number"
                step="0.001"
                outlined
                readonly
                dense
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="6">
              <v-text-field
                v-model="exportStartValueAlu"
                label="Startwert Aluminiumfelgen"
                type="number"
                step="0.001"
                outlined
                readonly
                dense
              ></v-text-field>
            </v-col>

            <v-col cols="12">
              <v-text-field
                v-model="exportStartValueOther"
                label="Startwert Sonstige"
                type="number"
                step="0.001"
                outlined
                readonly
                dense
              ></v-text-field>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="error" text @click="showExportDialog = false">Abbrechen</v-btn>
        <v-btn color="primary" text @click="runExport">Export</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</div>
    

      <v-divider></v-divider>

    </v-card>









<v-card
    style="
          width: 400px;
          margin: 20px;"
>

      <v-card-title>KW Abfrage</v-card-title>
      <v-container
          style="margin-left: 30px; margin-top: 10px;"
      >

        <v-select
            v-model="ckw"
            style="width: 200px;"
            :items="kw"
            label="Kalenderwoche"
            outlined
        ></v-select>
        <v-select
            v-model="cyear"
            style="width: 120px;"
            :items="year"
            label="Jahr"
            outlined
        ></v-select>



<!--
        <div
            style="
width: 90%;
text-align: right"
        >
          <v-btn
              outlined
              @click="getKWData"
          >Abfrage</v-btn>
        </div>
-->

        <v-row

        >
          <v-container>
            <span v-html="kw_text"></span>

            <v-btn
                class="mx-2"
                color="pink"
                dark
                rounded
                
                @click="createWochenreport()"
            >
                <v-icon left>mdi-printer-outline</v-icon>
                 <span v-if="!isGeneratingReport">Wochenbericht</span>
                 <!-- <span v-else style="text-transform: lowercase;">loading...</span> -->
                  <span v-else>loading...</span>
                  <v-progress-circular
                  v-if="isGeneratingReport"
                  indeterminate
                  size="20"
                  width="2"
                  color="white"
                  ></v-progress-circular>
              </v-btn>

          </v-container>

        </v-row>

      </v-container>

  <v-divider></v-divider>


  <kw-year-chart
      v-if="renderKwChart"
      title="KW Verlauf Schrottreifen"
      :key="`kw1-${chartKey}`"
      :values="kwValuesSchrott"
      :threshold="70"
      :year="this.cyear"
      y-title="Tonnen"
  />


  <kw-year-chart
      v-if="renderKwChart"
      title="KW Verlauf Gutreifen"
      :key="`kw2-${chartKey}`"
      :values="kwValuesGut"
      :threshold="70"
      :year="this.cyear"
      y-title="Tonnen"
  />

  <div
      style="
width: 100%;
margin-top: 20px;
text-align: center"
  >

    <v-btn
        class="mx-2"
        color="pink"
        dark
        rounded

        @click="getKWDataForYear()"
    >
      <v-icon left>mdi-abacus</v-icon>
      <span v-if="!isGenerating">KW Verlauf</span>
      <span v-else>loading...</span>
      <v-progress-circular
        v-if="isGenerating"
        indeterminate
        size="20"
         width="2"
          color="white"
          
        ></v-progress-circular>
       
      </v-btn>


  </div>



</v-card>







      <!--
          <v-card
              class="mx-auto justify-center"
              width="650"
              elevation-10

              color="white"

          >

            <v-card-text>
              <v-sheet color="#e91e63">
                <v-sparkline
                    :value="stock"
                    color="rgba(255, 255, 255, .7)"
                    height="250"
                    padding="24"
                    stroke-linecap="round"
                    smooth
                >
                  <template v-slot:label="item">
                    {{ item.value }}
                  </template>
                </v-sparkline>
              </v-sheet>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-text>
              <div class="text-h5 font-weight-thin">
                Lagerbestand Verlauf
              </div>
            </v-card-text>



          </v-card>
      -->



      <v-card
          style="
          background-color: rgba(245,243,243,0.46);
          width: 400px;
          height: 600px;
          margin: 20px;"
      >

        <v-card-title>Filter für Lagerbuchungen</v-card-title>

        <Dialog
            v-bind:label="'Datum'"
            v-bind:initial_date="filter_date"
            v-bind:clearable="true"
            v-model="filter_date"
            :key="filter_date"
            style="margin-left: 30px;"
        ></Dialog>


        <v-select
        label="Typ"
        v-model="filter_typ_selected"
        :items="filter_typ"
        item-text="state"
        item-value="abbr"

        style="
        display: table;
        margin: 0 auto;
        width: 350px;"
        >


        </v-select>



        <v-select
            label="Artikel"
            v-model="filter_article_selected"
            :items="filter_article"

            style="
        display: table;
        margin: 0 auto;
        width: 350px;"
        >

        </v-select>


        <v-select
            label="Abfallschlüssel"
            v-model="filter_wasteno_selected"
            :items="wasteno_list"

            style="
        display: table;
        margin: 0 auto;
        width: 350px;"
        >

        </v-select>





        <v-btn
            style="
        display: table;
        margin: 0 auto;
        width: 350px;"

            @click="loadDataFilter"

        >
          Filtern
        </v-btn>
        <div
        style="margin: 10px;"
        ></div>

        <v-btn
            style="

        display: table;
        margin: 0 auto;
        width: 350px;"

            @click="filterReset"

        >
          Reset
        </v-btn>







      </v-card>


    </v-row>



<div
style="margin-left: 20px;"
><h2>Lagerbuchungen</h2></div>
    <List
        v-if="renderComponent"

        v-bind:headers="headers"
        v-bind:formview="formview"
        v-bind:table="table"

        v-bind:default_limit="'700'"
        v-bind:default_sort="'date_timestamp'"
        v-bind:default_sort_typ="'DESC'"
        v-bind:extension="extension"
        v-bind:export_csv="true"
        @reload="reloadTotalWeight"
    ></List>

    <v-overlay
        :value="overlay"
    >

      <v-progress-circular
          indeterminate
          color="black"
          style="margin: 20px;"
      ></v-progress-circular>


      Monatsdurchschnitt wird neu berechnet...


    </v-overlay>


  </div>
</template>

<script>

import cLine from '@/components/cLine'
import List from '@/components/ListDefault'
import DialogDate from "@/components/DialogDate";
import KwYearChart from "@/components/KwYearChart";
import Vue from "vue";

import * as XLSX from 'xlsx-js-style';

export default {
  name: "ListStock",

  components: {
    cLine,
    List,
    DialogDate,
    KwYearChart
  },

  data () {
    return {

      showExportDialog: false,
      startDate: "", // Startdate from selected Year
      endDate: "",
      chartKey: 0,
      btnWeekReportDisabled: false,
      renderKwChart: false,
      isGenerating: false,
      isGeneratingReport: false,
      kwValues: [],
      kwValuesSchrott: [],
      kwValuesGut: [],
      exportType: 'range',
      exportTypes: [
       
        { text: 'Tag', value: 'range' },
        { text: 'KW ', value: 'kw' },
        { text: 'Monat ', value: 'monat' },
     
      ],

      exportStartValueGood: '0',
      exportStartValueScrapped: '0',
      exportStartValueSteel: '0',
      exportStartValueAlu: '0',
      exportStartValueOther: '0',
      parameterKeys: {
        good: 'export_startvalue_good',
        scrapped: 'export_startvalue_scrapped',
        steel: 'export_startvalue_steel',
        alu: 'export_startvalue_alu',
        other: 'export_startvalue_other'
      },

      stock: [
        {
          kw: '1', value: '200',
        },
        {
          kw: '2', value: '300',
        }
        ,
        {
          kw: '3', value: '400',
        }
        ,
        {
          kw: '4', value: '300',
        }
        ,
        {
          kw: '5', value: '350',
        }
        ,
        {
          kw: '6', value: '200',
        }
        ,
        {
          kw: '7', value: '600',
        }
        ,
        {
          kw: '8', value: '300',
        }
    ],

        kw: [
          1,
          2,
          3,
          4,
          5,
          6,
          7,
        ],

      year: [
        2020,
        2021,
        2022,
        2023,
        2024,
        2025,
        2026,
        2027,
        2028,
        2029,
        2030,
      ],

      ckw: '',
      cyear: '',

      selected_year: '', // current selected year for inventory


      search: '',
      formview: 'FormStock',
      mainview: 'ListStock',
      table: 'stock',

      total_weight_160103_good: 0, // Gutreifen
      total_weight_160103: 0, // Schrottreifen
      total_weight_160117: 0, // Stahlfelgen
      total_weight_160118: 0, // Alufelgen
      total_weight: 0,
      total_qty: 0,
      average_weight: 0,

      overlay: false,


      filter_date: '',
      filter_select: { state: 'Alle', abbr: '' },

      filter_typ_selected: '',
      filter_article_selected: '',
      filter_wasteno_selected: '',



      filter_typ: [
        { state: 'Alle', abbr: '' },
        { state: 'Eingänge', abbr: 'buy' },
        { state: 'Verkäufe', abbr: 'sell' },
        { state: 'Entsorgungen', abbr: 'disposal' },
      ],

      filter_article: [],
      filter_wasteno: [],

      renderComponent: true,
      renderComponentLineChart: false,

      chartData: Object,

      extension: '',

      report_mo: '',
      report_di: '',
      report_mi: '',
      report_do: '',
      report_fr: '',
      report_sa: '',
      report_so: '',


      wasteno: '160103', // Default wasteno
      wasteno_list: [], // Alle Abfallnummern


      date: '',
      

      kw_total_scrap: '',
      year_total_scrap: '',

      kw_total_good: '',
      year_total_good: '',



      kw_date_start: '',
      kw_date_end: '',

      kw_text: 'KW 1 / 2022: <b>0 Tonnen</b>',

    }
  },

  async created() {
    this.kw_text = ""
    this.date = this.$moment(Date.now()).format('DD.MM.YYYY')
    const currentYear = new Date().getFullYear()


    this.startDate = this.$moment().startOf('year').format('DD.MM.YYYY')

    this.selected_year = currentYear
    this.loadStockInventur(this.selected_year)

    await this.getAllWasteNo()
    await this.getAllArticle()

    // Lese Parameter aus
    await this.loadData()
    await this.reloadTotalWeight()

    // Befülle KW 53
    this.kw = []
    let n = 1;
    while (n < 54) {
      this.kw.push(n)
      n++;
    }

    // Setze Aktuelles Jahr und KW
    this.cyear  = Number(this.$moment(Date.now()).format("YYYY"))
    this.ckw    = Number(this.$moment(Date.now()).isoWeek())

  },

  mounted() {
  this.loadStartValues();
  },

  methods: {


  async loadStartValues() {
    console.log('Loading start values...');
/*
    try {
      
      await this.loadParameterByKey('export_startvalue_good', 'exportStartValueGood');
      await this.loadParameterByKey('export_startvalue_scrapped', 'exportStartValueScrapped');
      await this.loadParameterByKey('export_startvalue_steel', 'exportStartValueSteel');
      await this.loadParameterByKey('export_startvalue_alu', 'exportStartValueAlu');
      await this.loadParameterByKey('export_startvalue_other', 'exportStartValueOther');
      
      console.log('Loaded values:', {
        good: this.exportStartValueGood,
        scrapped: this.exportStartValueScrapped,
        steel: this.exportStartValueSteel,
        alu: this.exportStartValueAlu,
        other: this.exportStartValueOther
      });
    } catch (error) {
      console.error('Error loading start values:', error);
      this.setDefaultValues();
    }
*/

},


  async loadStockInventur(year){

  const param = {
    table: "stock_inventur",
    statement: "select",
    type: "detail",
    where: "true",
    selector: "year",
    value: year,
    short: "true",
    extension: "",
  };
  const data = {};

  try {
    const result = await this.$func.queryAPI(param, data);

    if(result && result.length > 0){
      this.exportStartValueGood = result[0].startvalue_good || '0';
      this.exportStartValueScrapped = result[0].startvalue_scrapped || '0';
      this.exportStartValueSteel = result[0].startvalue_steel || '0';
      this.exportStartValueAlu = result[0].startvalue_alu || '0';
      this.exportStartValueOther = result[0].startvalue_other || '0';
    }


  } catch (error) {
    console.error("Error fetching stock inventur:", error);
  }

},





async loadParameterByKey(key, propertyName) {
  console.log(`Loading parameter: ${key}`);


  // Use the exact format from your example
  const param = {
    table: "parameter",
    statement: "select",
    type: "detail",
    where: "true",
    selector: "schluessel",
    value: key,
    short: "true",
    extension: "",
  };
  const data = {};
  
  try {
    const result = await this.$func.queryAPI(param, data);
    console.log(`Result for ${key}:`, result);
    
    if (result && result.length > 0) {
      this[propertyName] = result[0].wert || '0';
      console.log(`Set ${propertyName} to ${this[propertyName]}`);
    } else {
      console.log(`No data found for ${key}, using default value '0'`);
      this[propertyName] = '0';
    }
  } catch (error) {
    console.error(`Error fetching parameter ${key}:`, error);
    this[propertyName] = '0';
  }



},

// Helper method to set all default values
setDefaultValues() {
  console.log('Setting default values for all parameters');
  this.exportStartValueGood = '0';
  this.exportStartValueScrapped = '0';
  this.exportStartValueSteel = '0';
  this.exportStartValueAlu = '0';
  this.exportStartValueOther = '0';
},
  
async saveStartValues() {
  try {
    const parameters = [
      { key: this.parameterKeys.good, property: 'exportStartValueGood' },
      { key: this.parameterKeys.scrapped, property: 'exportStartValueScrapped' },
      { key: this.parameterKeys.steel, property: 'exportStartValueSteel' },
      { key: this.parameterKeys.alu, property: 'exportStartValueAlu' },
      { key: this.parameterKeys.other, property: 'exportStartValueOther' }
    ];
    
    for (const param of parameters) {
      const value = this[param.property] || '0';
      console.log(`Saving ${param.key} with value ${value}`);
      const existingParams = await this.$func.queryAPI({
        table: 'parameter',
        statement: 'select',
        type: 'detail',
        where: 'true',
        selector: 'schluessel',
        value: param.key,
        short: 'true',
        extension: ''
      }, {});

      const statement = existingParams && existingParams.length > 0 ? 'update' : 'insert';
      console.log(`operation for ${param.key}: ${statement}`);

      const queryParam = {
        table: 'parameter',
        statement: statement,
        type: '',
        where: statement === 'update' ? 'true' : '',
        selector: statement === 'update' ? 'schluessel' : '',
        value: statement === 'update' ? param.key : '',
        short: 'true',
        extension: '',
        debug: true
      };

      const data = {
        schluessel: param.key,
        wert: value
      };

      const result = await this.$func.queryAPI(queryParam, data);
      console.log(`${statement} result for ${param.key}:`, result);
    }
    
    console.log('start values saved successfully');
    return true;
  } catch (error) {
    console.error('Error saving start values:', error);
    return false;
  }
},
    async csvexport(){

      // Einstellungen
      var param = {
        table: this.table,    // Tabellen Name
        statement: "custom",  // SELECT, INSERT, UPDATE, DELETE, CUSTOM
        type: "detail",       // detail, list (Bei SELECT) --> "detail" erfordert id, listfilter
        where: "true",
        selector: "",         // bei listflter -> id,name,test
        value: "",
        short: "false",       // Übermittlung nur von id
        debug: "false",       // Debug Ausgabe bei Select Abfrage
        // filter: "false",   // Bei true wird ein Feld gefiltert
        // filterfield: "",
        // filtervalue: "",
        // operator: "AND",   // AND für filterlist LIKE abfrage ()
        // Filter noch hinzufügen
        extension: "SELECT date, REPLACE(REPLACE(REPLACE(typ, 'buy', 'EINGANG'), 'disposal', 'VERSCHROTTUNG'), 'sell', 'VERKAUF'), wasteno, REPLACE(ROUND(SUM(weight), 3), '.', ','), REPLACE(ROUND(SUM(scrap_quantity_weight), 3), '.' , ','), REPLACE(ROUND(SUM(good_quantity_weight), 3), '.' , ',')  FROM `stock` WHERE wasteno <> '' AND date_timestamp >= '2009-01-01' AND date_timestamp <= '" + this.$moment(this.date, "DD.MM.YYYY").format("YYYY-MM-DD") + "' GROUP BY date_timestamp, typ, wasteno ORDER BY date_timestamp ASC" ,        // Erweiterung am Ende des SQL Befehls z.B. ORDER BY Colum ASC - Wird am Ende der SQL Abfrage hinzugefügt, bei CUSTOM entspricht das der gesamten Abfrage
      }

      var data = {
      }

      var result = await this.$func.queryAPI(param, data)
      console.log("csv" ,result)


      var ws = XLSX.utils.json_to_sheet(result)
      XLSX.utils.sheet_add_aoa(ws, [["DATUM", "TYP", "ABFALLSCHLÜSSEL", "GESAMTGEWICHT", "SCHROTTANTEIL", "GUTANTEIL"]], { origin: "A1" });

      var wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, ws, 'data')
      XLSX.writeFile(wb,'export.xlsx')

    },
  
  async runExport() {
  if (!this.startDate) {
    console.error("Bitte Startdatum auswählen");
    alert("Bitte Startdatum auswählen");
    return;
  }
  // await this.saveStartValues(); // Save the start values before exporting
  
  // If endDate is not set, use startDate as the endDate
  const endDateToUse = this.endDate || this.startDate;
  
  const formattedStartDate = this.formatDateForSQL(this.startDate);
  const formattedEndDate = this.formatDateForSQL(endDateToUse);
  
  console.log("--- start date ---: ", formattedStartDate);
  console.log("--- end date ---: ", formattedEndDate);

  this.showExportDialog = false;
  
  this.showExportDialog = false;
  this.periodexport(formattedStartDate, formattedEndDate, this.exportType,
     {
        good: parseFloat(this.exportStartValueGood) || 0,
        scrapped: parseFloat(this.exportStartValueScrapped) || 0,
        steel: parseFloat(this.exportStartValueSteel) || 0,
        alu: parseFloat(this.exportStartValueAlu) || 0,
        other: parseFloat(this.exportStartValueOther) || 0
      }

  );
},


formatDateForSQL(dateString) {
  if (!dateString) return '';
  
  try {
    if (dateString.includes('.')) {
      const parts = dateString.split('.');
      if (parts.length === 3) {
        return `${parts[2]}-${parts[1]}-${parts[0]}`;
      }
    }
    const date = new Date(dateString);
    if (isNaN(date.getTime())) {
      console.error("Invalid date:", dateString);
      return '';
    }
    
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    
    return `${year}-${month}-${day}`;
  } catch (error) {
    console.error("Error formatting date for SQL:", error);
    return '';
  }
},

// export stock between two dates
async periodexport(startDate, endDate, exportType = 'range', startValues = {}) {
  const today = new Date();
  
  const sqlStartDate = startDate ? this.formatDateForSQL(startDate) : this.formatDateForSQL(today);
  const sqlEndDate = endDate ? this.formatDateForSQL(endDate) : this.formatDateForSQL(today);
  
  console.log("SQL Start Date:", sqlStartDate);
  console.log("SQL End Date:", sqlEndDate);

  if (!sqlStartDate || !sqlEndDate) {
    console.error("Invalid date range");
    alert("Invalid date range. Please check your dates and try again.");
    return;
  }
  
  let groupBy, dateSelect;
      
  switch (exportType) {
    case 'kw':
      // Group by week number
      dateSelect = "CONCAT('KW ', IF(WEEK(STR_TO_DATE(date, '%d.%m.%Y'), 1) = 0, 1, WEEK(STR_TO_DATE(date, '%d.%m.%Y'), 1))) AS date";
      groupBy = "GROUP BY WEEK(STR_TO_DATE(date, '%d.%m.%Y'), 1)";
      break;
    case 'monat':
      // Group by month
      dateSelect = "CONCAT('Monat ', MONTH(STR_TO_DATE(date, '%d.%m.%Y'))) AS date";
      groupBy = "GROUP BY MONTH(STR_TO_DATE(date, '%d.%m.%Y'))";
      break;
    default:
      // date range 
      dateSelect = "date";
      groupBy = "GROUP BY date";
  }

  var param = {
    table: 'stock',
    statement: "custom",
    type: "detail",
    where: "true",
    selector: "",
    value: "",
    short: "false",
    debug: "true",
    extension: `SELECT ${dateSelect}, ` +

    // Eingang (Incoming)
    "ROUND(SUM(CASE WHEN typ = 'buy' AND wasteno = '160103' " + 
    "THEN COALESCE(CAST(good_quantity_weight AS DECIMAL(10,3)), weight) ELSE 0 END), 3) AS 'Eingang Guttreifen', " + 
    "ROUND(SUM(CASE WHEN typ = 'buy' AND wasteno = '160103' THEN COALESCE(scrap_quantity_weight, 0) ELSE 0 END), 3) AS 'Eingang Schrottreifen', " +
    "ROUND(SUM(CASE WHEN typ = 'buy' AND wasteno = '160117' THEN weight ELSE 0 END), 3) AS 'Eingang Stahlfelge', " +
    "ROUND(SUM(CASE WHEN typ = 'buy' AND wasteno = '160118' THEN weight ELSE 0 END), 3) AS 'Eingang Alufelge', " +
    "ROUND(SUM(CASE WHEN typ = 'buy' AND wasteno NOT IN ('160103', '160117', '160118') THEN weight ELSE 0 END), 3) AS 'Eingang Sonstige', " +
    "ROUND(SUM(CASE WHEN typ = 'buy' THEN weight ELSE 0 END), 3) AS 'Eingang GESAMT', " +

  // Ausgang (Outgoing)
    "ROUND(SUM(CASE WHEN (typ = 'sell' OR typ = 'disposal') AND wasteno = '160103' THEN COALESCE(good_quantity_weight, weight) ELSE 0 END), 3) AS 'Ausgang Gutreifen'," +
    "ROUND(SUM(CASE WHEN (typ = 'sell' OR typ = 'disposal') AND wasteno = '160103' THEN COALESCE(scrap_quantity_weight, weight) ELSE 0 END), 3) AS 'Ausgang Schrottreifen' ," +
    "ROUND(SUM(CASE WHEN (typ = 'sell' OR typ = 'disposal') AND wasteno = '160117' THEN weight ELSE 0 END), 3) AS 'Ausgang Stahlfelge', " +
    "ROUND(SUM(CASE WHEN (typ = 'sell' OR typ = 'disposal') AND wasteno = '160118' THEN weight ELSE 0 END), 3) AS 'Ausgang Alufelge', " +
    "ROUND(SUM(CASE WHEN (typ = 'sell' OR typ = 'disposal') AND wasteno NOT IN ('160103', '160117', '160118') AND article_name NOT IN ('Leerfahrt', 'Logbox') THEN weight ELSE 0 END), 3) AS 'Ausgang Sonstige', " +

    "ROUND(SUM(CASE WHEN typ = 'sell' OR typ = 'disposal' THEN weight ELSE 0 END), 3) AS 'Ausgang GESAMT', " +

    // Bestand (Stock) 
    `ROUND(${startValues.good || 0} + (` +
    "SELECT COALESCE(SUM(CASE " +
    "WHEN t2.typ = 'buy' AND t2.wasteno = '160103' " +
    "THEN COALESCE(CAST(t2.good_quantity_weight AS DECIMAL(10,3)), t2.weight) " +
    "WHEN t2.typ = 'sell' AND t2.wasteno = '160103' " +
    "THEN -ABS(t2.weight) " +
    "ELSE 0 END), 0) " +
    "FROM stock t2 " +
    "WHERE t2.date_timestamp <= stock.date_timestamp " +
    "AND t2.date_timestamp >= '" + sqlStartDate + "'), 3) AS 'Bestand Gutreifen', " +

    `ROUND(${startValues.scrapped || 0} + (` +
    "SELECT COALESCE(SUM(CASE " +
    "WHEN t2.typ = 'buy' AND t2.wasteno = '160103' " +
    "THEN COALESCE(t2.scrap_quantity_weight, 0) " +
    "WHEN t2.typ = 'disposal' AND t2.wasteno = '160103' " +
    "THEN -ABS(t2.weight) " +
    "ELSE 0 END), 0) " +
    "FROM stock t2 " +
    "WHERE t2.date_timestamp <= stock.date_timestamp " +
    "AND t2.date_timestamp >= '" + sqlStartDate + "'), 3) AS 'Bestand Schrottreifen', " +

    `ROUND(${startValues.steel || 0} + (` +
    "SELECT COALESCE(SUM(CASE " +
    "WHEN t2.typ = 'buy' AND t2.wasteno = '160117' " +
    "THEN t2.weight " +
    "WHEN t2.typ IN ('sell', 'disposal') AND t2.wasteno = '160117' " +
    "THEN -ABS(t2.weight) " +
    "ELSE 0 END), 0) " +
    "FROM stock t2 " +
    "WHERE t2.date_timestamp <= stock.date_timestamp " +
    "AND t2.date_timestamp >= '" + sqlStartDate + "'), 3) AS 'Bestand Stahlfelge', " +

    `ROUND(${startValues.alu || 0} + (` +
    "SELECT COALESCE(SUM(CASE " +
    "WHEN t2.typ = 'buy' AND t2.wasteno = '160118' " +
    "THEN t2.weight " +
    "WHEN t2.typ IN ('sell', 'disposal') AND t2.wasteno = '160118' " +
    "THEN -ABS(t2.weight) " +
    "ELSE 0 END), 0) " +
    "FROM stock t2 " +
    "WHERE t2.date_timestamp <= stock.date_timestamp " +
    "AND t2.date_timestamp >= '" + sqlStartDate + "'), 3) AS 'Bestand Alufelge', " +

    `ROUND(${startValues.other || 0} + (` +
    "SELECT COALESCE(SUM(CASE " +
    "WHEN t2.typ = 'buy' AND t2.wasteno NOT IN ('160103', '160117', '160118') " +
    "THEN t2.weight " +
    "WHEN t2.typ IN ('sell', 'disposal') AND t2.wasteno NOT IN ('160103', '160117', '160118') " +
    "THEN -ABS(t2.weight) " +
    "ELSE 0 END), 0) " +
    "FROM stock t2 " +
    "WHERE t2.date_timestamp <= stock.date_timestamp " +
    "AND t2.date_timestamp >= '" + sqlStartDate + "'), 3) AS 'Bestand Sonstige', " +


    //(sum of Schrottreifen + Stahlfelge + Alufelge + Sonstige)
    `ROUND((${startValues.scrapped || 0} + ${startValues.steel || 0} + ${startValues.alu || 0} + ${startValues.other || 0}) + (` +
    "SELECT COALESCE(SUM(CASE " +
    "WHEN (t2.typ = 'buy' AND t2.wasteno = '160103') THEN COALESCE(t2.scrap_quantity_weight, 0) " +
    "WHEN (t2.typ = 'buy' AND t2.wasteno IN ('160117', '160118')) THEN t2.weight " +
    "WHEN (t2.typ = 'buy' AND t2.wasteno NOT IN ('160103', '160117', '160118')) THEN t2.weight " +
    "WHEN (t2.typ = 'disposal' AND t2.wasteno = '160103') THEN -ABS(t2.weight) " +
    "WHEN (t2.typ IN ('sell', 'disposal') AND t2.wasteno IN ('160117', '160118')) THEN -ABS(t2.weight) " +
    "WHEN (t2.typ IN ('sell', 'disposal') AND t2.wasteno NOT IN ('160103', '160117', '160118')) THEN -ABS(t2.weight) " +
    "ELSE 0 END), 0) " +
    "FROM stock t2 " +
    "WHERE t2.date_timestamp <= stock.date_timestamp " +
    "AND t2.date_timestamp >= '" + sqlStartDate + "'), 3) AS 'Bestand SCHROTT', " +

    // Bestand GESAMT
    `ROUND((${startValues.good || 0} + ${startValues.scrapped || 0} + ${startValues.steel || 0} + ${startValues.alu || 0} + ${startValues.other || 0}) + (` +
    "SELECT COALESCE(SUM(CASE " +
    "WHEN t2.typ = 'buy' THEN t2.weight " +
    "WHEN t2.typ IN ('sell', 'disposal') THEN -ABS(t2.weight) " +
    "ELSE 0 END), 0) " +
    "FROM stock t2 " +
    "WHERE t2.date_timestamp <= stock.date_timestamp " +
    "AND t2.date_timestamp >= '" + sqlStartDate + "'), 3) AS 'Bestand GESAMT' " +

    "FROM stock " +
    "WHERE date_timestamp >= '" + sqlStartDate + "' AND date_timestamp <= '" + sqlEndDate + "' " +
    `${groupBy} ` +
    "ORDER BY STR_TO_DATE(date, '%d.%m.%Y') ASC"
  };
  var data = {};
  console.log("Query params:", param);
  console.log('Generated SQL Query:', param.extension);
 
  try {
    var result = await this.$func.queryAPI(param, data);
    console.log('API result:', result);
   
    if (!result || !Array.isArray(result) || result.length === 0) {
      console.warn("No data found for the given date range.");
      return;
    }
   
    console.log("Period export valid result:", result);
    
    // Create the Excel workbook and worksheet
    var wb = XLSX.utils.book_new();
    var ws = XLSX.utils.json_to_sheet([], { header: [] });


    const header1 = [
      "",
      "EINGANG ", "", "", "", "", "",
      "AUSGANG", "", "", "", "", "", "",
      "BESTAND ", "", "", "", "", "", ""
    ];

    
    const header2 = [
      "Datum",
      "Eingang\nGuttreifen\n160103",
      "Eingang\nSchrottreifen\n160103",
      "Eingang\nStahlfelge\n160117",
      "Eingang\nAlufelge\n160118",
      "Eingang\nSonstige\n160117",
      "Eingang\nGESAMT",
      "Ausgang\nGutreifen\n160103",
      "Ausgang\nSchrottreifen\n160103",
      "Verwerter / Korrektur",
      "Ausgang\nStahlfelge\n160117",
      "Ausgang\nAlufelge\n160118",
      "Ausgang\nSonstige\n160117",
      "Ausgang\nGESAMT",
      "Bestand\nGutreifen\n160103",
      "Bestand\nSchrottreifen\n160103",
      "Bestand\nStahlfelge\n160117",
      "Bestand\nAlufelge\n160118",
      "Bestand\nSonstige\n160117",
      "Bestand\nSCHROTT\n160103",
      "Bestand\nGESAMT"
    ];
    
    XLSX.utils.sheet_add_aoa(ws, [header1, header2], { origin: "A1" });

    const headerStyle = {
      font: { bold: true, color: { rgb: "000000" } }, 
      alignment: { horizontal: "center", vertical: "center", wrapText: true },
      fill: { fgColor: { rgb: "FFFFFF" } }
    };

    const sectionStyles = {
      eingang: { 
        fill: { fgColor: { rgb: "D9E1F2" } }, // Light blue
        border: {
          right: { style: "medium", color: { rgb: "000000" } } 
        }
      },
      ausgang: { 
        fill: { fgColor: { rgb: "D9E1F2" } },
        border: {
          left: { style: "medium", color: { rgb: "000000" } }, 
          right: { style: "medium", color: { rgb: "000000" } } 
        }
      },
      bestand: { 
        fill: { fgColor: { rgb: "D9E1F2" } },
        border: {
          left: { style: "medium", color: { rgb: "000000" } }, 
          right: { style: "medium", color: { rgb: "000000" } }
        }
      }
    };

    // styles to headers
    const range = { s: { r: 0, c: 0 }, e: { r: 1, c: 20 } };
    for (let C = range.s.c; C <= range.e.c; ++C) {
      for (let R = range.s.r; R <= range.e.r; ++R) {
        const cell_address = { c: C, r: R };
        const cell_ref = XLSX.utils.encode_cell(cell_address);
        
        if (!ws[cell_ref]) ws[cell_ref] = { t: 's', v: '' };
        if (!ws[cell_ref].s) ws[cell_ref].s = {};
        
        // base header style to all header cells
        Object.assign(ws[cell_ref].s, headerStyle);
        
        // borders to all cells
        ws[cell_ref].s.border = {
          top: { style: "thin", color: { rgb: "000000" } },
          bottom: { style: "thin", color: { rgb: "000000" } },
          left: { style: "thin", color: { rgb: "000000" } },
          right: { style: "thin", color: { rgb: "000000" } }
        };
        
        // section-specific styles to first header row
        if (R === 0) {
          if (C >= 1 && C <= 6) {
            Object.assign(ws[cell_ref].s, sectionStyles.eingang);
            // right border for last Eingang column
            if (C === 6) {
              ws[cell_ref].s.border.right = { style: "medium", color: { rgb: "000000" } };
            }
          }
          if (C >= 7 && C <= 12) {
            Object.assign(ws[cell_ref].s, sectionStyles.ausgang);
            //  left border for first Ausgang column
            if (C === 7) {
              ws[cell_ref].s.border.left = { style: "medium", color: { rgb: "000000" } };
            }
            //  right border for last Ausgang column
            if (C === 12) {
              ws[cell_ref].s.border.right = { style: "medium", color: { rgb: "000000" } };
            }
          }
          if (C >= 13 && C <= 20) {
            Object.assign(ws[cell_ref].s, sectionStyles.bestand);
            // left border for first Bestand column
            if (C === 13) {
              ws[cell_ref].s.border.left = { style: "medium", color: { rgb: "000000" } };
            }
          }
        }
      }
    }

    // borders between sections in the second header row
    for (let C = 1; C <= 20; ++C) {
      const cell_address = { c: C, r: 1 };
      const cell_ref = XLSX.utils.encode_cell(cell_address);
      
      if (!ws[cell_ref]) continue;
      if (!ws[cell_ref].s) ws[cell_ref].s = {};
      if (!ws[cell_ref].s.border) ws[cell_ref].s.border = {};
      
      if (C === 6) {
        ws[cell_ref].s.border.right = { style: "medium", color: { rgb: "000000" } };
      }
      // Left thick border before Ausgang section
      if (C === 7) {
        ws[cell_ref].s.border.left = { style: "medium", color: { rgb: "000000" } };
      }
      // Right thick border after Ausgang section
      if (C === 12) {
        ws[cell_ref].s.border.right = { style: "medium", color: { rgb: "000000" } };
      }
      // Left thick border before Bestand section
      if (C === 13) {
        ws[cell_ref].s.border.left = { style: "medium", color: { rgb: "000000" } };
      }
    }

    // Data rows
    const rows = result.map(item => [
      item.date,
      item['Eingang Guttreifen'], item['Eingang Schrottreifen'], item['Eingang Stahlfelge'], item['Eingang Alufelge'], 
      item['Eingang Sonstige'], item['Eingang GESAMT'],
      item['Ausgang Gutreifen'], item['Ausgang Schrottreifen'], "", item['Ausgang Stahlfelge'], item['Ausgang Alufelge'],
      item['Ausgang Sonstige'], item['Ausgang GESAMT'],
      item['Bestand Gutreifen'], item['Bestand Schrottreifen'], item['Bestand Stahlfelge'], item['Bestand Alufelge'],
      item['Bestand Sonstige'],item['Bestand SCHROTT'], item['Bestand GESAMT']
    ]);

    XLSX.utils.sheet_add_aoa(ws, rows, { origin: "A3" });

    // Calculate totals for each column
    const totals = {
      date: 'TOTAL',
      'Eingang Guttreifen': 0,
      'Eingang Schrottreifen': 0,
      'Eingang Stahlfelge': 0,
      'Eingang Alufelge': 0,
      'Eingang Sonstige': 0,
      'Eingang GESAMT': 0,
      'Ausgang Gutreifen': 0,
      'Ausgang Schrottreifen': 0,
      'Ausgang Stahlfelge': 0,
      'Ausgang Alufelge': 0,
      'Ausgang Sonstige': 0,
      'Ausgang GESAMT': 0
    };

    // Calculate sums for each column
    result.forEach(item => {
    
      totals['Eingang Guttreifen'] += parseFloat(item['Eingang Guttreifen'] || 0);
      totals['Eingang Schrottreifen'] += parseFloat(item['Eingang Schrottreifen'] || 0);
      totals['Eingang Stahlfelge'] += parseFloat(item['Eingang Stahlfelge'] || 0);
      totals['Eingang Alufelge'] += parseFloat(item['Eingang Alufelge'] || 0);
      totals['Eingang Sonstige'] += parseFloat(item['Eingang Sonstige'] || 0);
      totals['Eingang GESAMT'] += parseFloat(item['Eingang GESAMT'] || 0);
      
      totals['Ausgang Gutreifen'] += parseFloat(item['Ausgang Gutreifen'] || 0);
      totals['Ausgang Schrottreifen'] += parseFloat(item['Ausgang Schrottreifen'] || 0);
      totals['Ausgang Stahlfelge'] += parseFloat(item['Ausgang Stahlfelge'] || 0);
      totals['Ausgang Alufelge'] += parseFloat(item['Ausgang Alufelge'] || 0);
      totals['Ausgang Sonstige'] += parseFloat(item['Ausgang Sonstige'] || 0);
      totals['Ausgang GESAMT'] += parseFloat(item['Ausgang GESAMT'] || 0);
    });
      Object.keys(totals).forEach(key => {
        if (key !== 'date' && typeof totals[key] === 'number') {
          let numStr = totals[key].toFixed(3);
          let decimalPart = numStr.substring(numStr.lastIndexOf('.') + 1);
          let integerPart = numStr.substring(0, numStr.lastIndexOf('.'))
                                .replace(/\B(?=(\d{3})+(?!\d))/g, '.');
          totals[key] = integerPart + '.' + decimalPart;
        }
      });

    // Create the totals row
    const totalsRow = [
      totals.date,
      totals['Eingang Guttreifen'], 
      totals['Eingang Schrottreifen'],
      totals['Eingang Stahlfelge'],
      totals['Eingang Alufelge'],
      totals['Eingang Sonstige'],
      totals['Eingang GESAMT'],
      totals['Ausgang Gutreifen'],
      totals['Ausgang Schrottreifen'],
      '',
      totals['Ausgang Stahlfelge'],
      totals['Ausgang Alufelge'],
      totals['Ausgang Sonstige'],
      totals['Ausgang GESAMT'],
      '', '', '', '', '', '', ''
    ];

    const totalRowIndex = rows.length + 3;
    XLSX.utils.sheet_add_aoa(ws, [totalsRow], { origin: `A${totalRowIndex}` });

    // Style the totals row
    for (let C = 0; C <= 20; ++C) {
      const cell_ref = XLSX.utils.encode_cell({ r: totalRowIndex - 1, c: C });
      
      if (!ws[cell_ref]) ws[cell_ref] = { t: 's', v: '' };
      if (!ws[cell_ref].s) ws[cell_ref].s = {};
      
      
      // Bold text for all cells in totals row
      ws[cell_ref].s = {
        font: { bold: true },
        border: {
          top: { style: "medium", color: { rgb: "000000" } },
          bottom: { style: "thin", color: { rgb: "000000" } },
          left: { style: "thin", color: { rgb: "000000" } },
          right: { style: "thin", color: { rgb: "000000" } }
        }
      };
      
      // background colors
      if (C >= 1 && C <= 6) {
        ws[cell_ref].s.fill = { fgColor: { rgb: "D9E1F2" } }; // Eingang section
        if (C === 6) {
          ws[cell_ref].s.border.right = { style: "medium", color: { rgb: "000000" } };
        }
      }
      if (C >= 7 && C <= 12) {
        ws[cell_ref].s.fill = { fgColor: { rgb: "D9E1F2" } }; // Ausgang section
        if (C === 7) {
          ws[cell_ref].s.border.left = { style: "medium", color: { rgb: "000000" } };
        }
        if (C === 12) {
          ws[cell_ref].s.border.right = { style: "medium", color: { rgb: "000000" } };
        }
      }
      if (C >= 13 && C <= 20) {
        if (C === 13) {
          ws[cell_ref].s.border.left = { style: "medium", color: { rgb: "000000" } };
        }
        if (C === 20) {
          ws[cell_ref].s.border.right = { style: "medium", color: { rgb: "000000" } };
        }
      }
    }

    // Vertical borders between sections for all rows (including data rows)
    for (let R = 0; R <= totalRowIndex; ++R) {
      // Border between EINGANG and AUSGANG (after column 6)
      const borderRightEingang = XLSX.utils.encode_cell({ c: 6, r: R });
      if (!ws[borderRightEingang]) ws[borderRightEingang] = { t: 's', v: '' };
      if (!ws[borderRightEingang].s) ws[borderRightEingang].s = {};
      if (!ws[borderRightEingang].s.border) ws[borderRightEingang].s.border = {};
      ws[borderRightEingang].s.border.right = { style: "medium", color: { rgb: "000000" } };

      // left border to first column of next section for better visual
      const borderLeftEingang = XLSX.utils.encode_cell({ c: 1, r: R });
      if (!ws[borderLeftEingang]) ws[borderLeftEingang] = { t: 's', v: '' };
      if (!ws[borderLeftEingang].s) ws[borderLeftEingang].s = {};
      if (!ws[borderLeftEingang].s.border) ws[borderLeftEingang].s.border = {};
      ws[borderLeftEingang].s.border.left = { style: "medium", color: { rgb: "000000" } };

      // Border between AUSGANG and BESTAND (after column 12)
      const borderRightAusgang = XLSX.utils.encode_cell({ c: 12, r: R });
      if (!ws[borderRightAusgang]) ws[borderRightAusgang] = { t: 's', v: '' };
      if (!ws[borderRightAusgang].s) ws[borderRightAusgang].s = {};
      if (!ws[borderRightAusgang].s.border) ws[borderRightAusgang].s.border = {};
      ws[borderRightAusgang].s.border.right = { style: "medium", color: { rgb: "000000" } };

      if (R > 0) { 
        // Left border of AUSGANG (column 7)
        const borderLeftAusgang = XLSX.utils.encode_cell({ c: 7, r: R });
        if (!ws[borderLeftAusgang]) ws[borderLeftAusgang] = { t: 's', v: '' };
        if (!ws[borderLeftAusgang].s) ws[borderLeftAusgang].s = {};
        if (!ws[borderLeftAusgang].s.border) ws[borderLeftAusgang].s.border = {};
        ws[borderLeftAusgang].s.border.left = { style: "medium", color: { rgb: "000000" } };

        // Left border of BESTAND (column 13)
        const borderLeftBestand = XLSX.utils.encode_cell({ c: 13, r: R });
        if (!ws[borderLeftBestand]) ws[borderLeftBestand] = { t: 's', v: '' };
        if (!ws[borderLeftBestand].s) ws[borderLeftBestand].s = {};
        if (!ws[borderLeftBestand].s.border) ws[borderLeftBestand].s.border = {};
        ws[borderLeftBestand].s.border.left = { style: "medium", color: { rgb: "000000" } };
        
        // right border to first column of next section for better visual
        const borderRightBestand = XLSX.utils.encode_cell({ c: 20, r: R });
        if (!ws[borderRightBestand]) ws[borderRightBestand] = { t: 's', v: '' };
        if (!ws[borderRightBestand].s) ws[borderRightBestand].s = {};
        if (!ws[borderRightBestand].s.border) ws[borderRightBestand].s.border = {};
        ws[borderRightBestand].s.border.right = { style: "medium", color: { rgb: "000000" } };
      }
    }

    // Merged regions 
    ws['!merges'] = [
      { s: { r: 0, c: 1 }, e: { r: 0, c: 6 } },  // EINGANG
      { s: { r: 0, c: 7 }, e: { r: 0, c: 12 } }, // AUSGANG
      { s: { r: 0, c: 13 }, e: { r: 0, c: 20 } } // BESTAND
    ];

    // Column widths
    ws['!cols'] = [
      { wch: 12 }, // Date column width
      { wch: 10 }, { wch: 12 }, { wch: 10 }, { wch: 10 }, { wch: 10 }, { wch: 10 }, // Eingang columns
      { wch: 10 }, { wch: 12 }, { wch: 80 }, { wch: 10 }, { wch : 10 }, { wch: 10 }, { wch: 10 }, // Ausgang columns
      { wch: 10 }, { wch: 12 }, { wch: 10 }, { wch: 10 }, { wch: 10 },{ wch: 10 }, { wch: 10 }  // Bestand columns
  ];

    // Row height for header rows
    ws['!rows'] = [
      { hpt: 30 }, 
      { hpt: 45 }
    ];

    // Freeze header rows
    ws['!freeze'] = { xSplit: 0, ySplit: 2, topLeftCell: "A3" };

    // Append the worksheet to the workbook
    XLSX.utils.book_append_sheet(wb, ws, 'Data');


    let filename = 'period_export';
    if (exportType === 'kw') filename = 'weekly_stock_export';
    if (exportType === 'monat') filename = 'monthly_stock_export';
    if (exportType === 'range') filename = 'single_day_stock_export';

    XLSX.writeFile(wb, `${filename}.xlsx`);

    return result;
  } catch (error) {
    console.error("Error fetching period export data:", error);
  }
},
    
    // Helper function to calculate weekly and monthly summaries
    calculateSummaries(data) {
      const summaries = [];
      
      // Group by week and month
      const weeklyData = {};
      const monthlyData = {};
      
      data.forEach(row => {
        const date = new Date(row.date);
        
        // Get week number (KW)
        const startDate = new Date(date.getFullYear(), 0, 1);
        const days = Math.floor((date - startDate) / (24 * 60 * 60 * 1000));
        const weekNumber = Math.max(1, Math.ceil((days + startDate.getDay() + 1) / 7));
        const weekKey = `KW ${weekNumber}`;
        
        // Get month
        const monthKey = `Monat ${date.getMonth() + 1}`;
        
        // Initialize or update weekly data
        if (!weeklyData[weekKey]) {
          weeklyData[weekKey] = this.createEmptyDataRow();
        }
        
        // Initialize or update monthly data
        if (!monthlyData[monthKey]) {
          monthlyData[monthKey] = this.createEmptyDataRow();
        }
        
        // Sum data for week and month
        this.sumDataRows(weeklyData[weekKey], row);
        this.sumDataRows(monthlyData[monthKey], row);
      });
      
      // Convert to array format
      Object.entries(weeklyData).forEach(([key, value]) => {
        summaries.push({ date: key, ...value });
      });
      
      Object.entries(monthlyData).forEach(([key, value]) => {
        summaries.push({ date: key, ...value });
      });
      
      return summaries;
    },
    
    // Helper to create an empty data row with zeros
    createEmptyDataRow() {
      return {
        "Eingang Guttreifen": 0, "Eingang Schrottreifen": 0, "Eingang Stahlfelge": 0, "Eingang Alufelge ": 0, 
        "Eingang Sonstige": 0, "Eingang TOTAL": 0,
        "Ausgang Gutreifen ": 0, "Ausgang Schrottreifen ": 0, "Ausgang Stahlfelge ": 0, "Ausgang Alu": 0,
        "Ausgang Sonstige": 0,"Ausgang TOTAL": 0,
        "Bestand Gutreifen ": 0, "Bestand Schrottreifen ": 0, "Bestand Stahlfelge ": 0, "Bestand Alu": 0, 
        "Bestand Sonstige": 0,"Bestand Total": 0
      };
    },
    
   // Helper to sum values between two data rows
    sumDataRows(target, source) {
      Object.keys(target).forEach(key => {
        if (source[key] !== undefined) {
          target[key] += parseFloat(source[key] || 0);
        }
      });

    },
  
// //test the export function
// testExport() {
//   console.log("Test export");
//   const testStartDate = '01.01.2024';  
//   const testEndDate = '31.12.2024';    
//   this.periodexport(testStartDate, testEndDate);
// }
// ,
    // Ermittel alle Abfallnummern
    async getAllWasteNo(){

      console.log("getAllWasteNo")

      // Einstellungen
      var param = {
        table: "article",    // Tabellen Name
        statement: "custom",  // SELECT, INSERT, UPDATE, DELETE, CUSTOM
        type: "detail",       // detail, list (Bei SELECT) --> "detail" erfordert id, listfilter
        where: "true",
        selector: "",         // bei listflter -> id,name,test
        value: "",
        short: "false",       // Übermittlung nur von id
        debug: "false",       // Debug Ausgabe bei Select Abfrage
        // filter: "false",   // Bei true wird ein Feld gefiltert
        // filterfield: "",
        // filtervalue: "",
        // operator: "AND",   // AND für filterlist LIKE abfrage ()
        // Filter noch hinzufügen
        extension: "SELECT wasteno  FROM `article` GROUP BY wasteno"

      }

      // Daten -> Werden nur bei Insert oder Update gesendet
      var data = {
      }

      var result = await this.$func.queryAPI(param, data)
      console.log(result)


      for (var i1 = 0; i1 < result.length; i1++) {

        if(result[i1]["wasteno"] != "0"){
          this.wasteno_list.push(result[i1]["wasteno"])
        }

      }

      console.log(this.wasteno_list)


    },


    // Ermittel alle Abfallnummern
    async getAllArticle(){

      console.log("getAllArticle")

      // Einstellungen
      var param = {
        table: "article",    // Tabellen Name
        statement: "custom",  // SELECT, INSERT, UPDATE, DELETE, CUSTOM
        type: "detail",       // detail, list (Bei SELECT) --> "detail" erfordert id, listfilter
        where: "true",
        selector: "",         // bei listflter -> id,name,test
        value: "",
        short: "false",       // Übermittlung nur von id
        debug: "false",       // Debug Ausgabe bei Select Abfrage
        // filter: "false",   // Bei true wird ein Feld gefiltert
        // filterfield: "",
        // filtervalue: "",
        // operator: "AND",   // AND für filterlist LIKE abfrage ()
        // Filter noch hinzufügen
        extension: "SELECT name  FROM `article` GROUP BY name ORDER BY name ASC"

      }

      // Daten -> Werden nur bei Insert oder Update gesendet
      var data = {
      }

      var result = await this.$func.queryAPI(param, data)
      console.log(result)

      for (var i1 = 0; i1 < result.length; i1++) {
          this.filter_article.push(result[i1]["name"])
      }

      console.log(this.wasteno_list)

    },





    async buildChart(){

      // Einstellungen
      var param = {
        table: "stock_day",    // Tabellen Name
        statement: "custom",  // SELECT, INSERT, UPDATE, DELETE, CUSTOM
        type: "detail",       // detail, list (Bei SELECT) --> "detail" erfordert id, listfilter
        where: "true",
        selector: "",         // bei listflter -> id,name,test
        value: "",
        short: "false",       // Übermittlung nur von id
        debug: "false",       // Debug Ausgabe bei Select Abfrage
        // filter: "false",   // Bei true wird ein Feld gefiltert
        // filterfield: "",
        // filtervalue: "",
        // operator: "AND",   // AND für filterlist LIKE abfrage ()
        // Filter noch hinzufügen
        extension: "SELECT count(*), sum(saldo_scrap), month  FROM `stock_day` WHERE wasteno = '160103' AND  date_timestamp >= '" + this.$moment(Date.now()).subtract(11,'months').endOf('month').format("YYYY-MM-DD") + "' AND date_timestamp <= '" + this.$moment(Date.now()).format("YYYY-MM-DD") + "' GROUP BY month ORDER BY date_timestamp ASC" ,        // Erweiterung am Ende des SQL Befehls z.B. ORDER BY Colum ASC - Wird am Ende der SQL Abfrage hinzugefügt, bei CUSTOM entspricht das der gesamten Abfrage

      }

      console.log(param.extension)


      // Daten -> Werden nur bei Insert oder Update gesendet
      var data = {
      }

      var result = await this.$func.queryAPI(param, data)
      console.log("HIER!!!!")
      console.log(result)

      if(result.length == 0){
        return
      }



      // Einstellungen
      var param1 = {
        table: "stock_day",    // Tabellen Name
        statement: "custom",  // SELECT, INSERT, UPDATE, DELETE, CUSTOM
        type: "detail",       // detail, list (Bei SELECT) --> "detail" erfordert id, listfilter
        where: "true",
        selector: "",         // bei listflter -> id,name,test
        value: "",
        short: "false",       // Übermittlung nur von id
        debug: "false",       // Debug Ausgabe bei Select Abfrage
        // filter: "false",   // Bei true wird ein Feld gefiltert
        // filterfield: "",
        // filtervalue: "",
        // operator: "AND",   // AND für filterlist LIKE abfrage ()
        // Filter noch hinzufügen
        extension: "SELECT count(*), sum(saldo_scrap), month  FROM `stock_day` WHERE wasteno = '160117' AND  date_timestamp >= '" + this.$moment(Date.now()).subtract(11,'months').endOf('month').format("YYYY-MM-DD") + "' AND date_timestamp <= '" + this.$moment(Date.now()).format("YYYY-MM-DD") + "' GROUP BY month ORDER BY date_timestamp ASC" ,        // Erweiterung am Ende des SQL Befehls z.B. ORDER BY Colum ASC - Wird am Ende der SQL Abfrage hinzugefügt, bei CUSTOM entspricht das der gesamten Abfrage

      }

      // Daten -> Werden nur bei Insert oder Update gesendet
      var data1 = {
      }

      var result1 = await this.$func.queryAPI(param1, data1)
      console.log(result1)

      if(result1.length < 12){

        result1.unshift({'count(*)': '0', 'sum(saldo_scrap)': '0', 'month': ''})
        result1.unshift({'count(*)': '0', 'sum(saldo_scrap)': '0', 'month': ''})
        result1.unshift({'count(*)': '0', 'sum(saldo_scrap)': '0', 'month': ''})
        result1.unshift({'count(*)': '0', 'sum(saldo_scrap)': '0', 'month': ''})

      }

      // Einstellungen
      var param2 = {
        table: "stock_day",    // Tabellen Name
        statement: "custom",  // SELECT, INSERT, UPDATE, DELETE, CUSTOM
        type: "detail",       // detail, list (Bei SELECT) --> "detail" erfordert id, listfilter
        where: "true",
        selector: "",         // bei listflter -> id,name,test
        value: "",
        short: "false",       // Übermittlung nur von id
        debug: "false",       // Debug Ausgabe bei Select Abfrage
        // filter: "false",   // Bei true wird ein Feld gefiltert
        // filterfield: "",
        // filtervalue: "",
        // operator: "AND",   // AND für filterlist LIKE abfrage ()
        // Filter noch hinzufügen
        extension: "SELECT count(*), sum(saldo_scrap), month  FROM `stock_day` WHERE wasteno = '160118' AND  date_timestamp >= '" + this.$moment(Date.now()).subtract(11,'months').endOf('month').format("YYYY-MM-DD") + "' AND date_timestamp <= '" + this.$moment(Date.now()).format("YYYY-MM-DD") + "' GROUP BY month ORDER BY date_timestamp ASC" ,        // Erweiterung am Ende des SQL Befehls z.B. ORDER BY Colum ASC - Wird am Ende der SQL Abfrage hinzugefügt, bei CUSTOM entspricht das der gesamten Abfrage

      }

      // Daten -> Werden nur bei Insert oder Update gesendet
      var data2 = {
      }

      var result2 = await this.$func.queryAPI(param2, data2)
      console.log(result2)


      if(result2.length < 12){

        result2.unshift({'count(*)': '0', 'sum(saldo_scrap)': '0', 'month': ''})
        result2.unshift({'count(*)': '0', 'sum(saldo_scrap)': '0', 'month': ''})
        result2.unshift({'count(*)': '0', 'sum(saldo_scrap)': '0', 'month': ''})
        result2.unshift({'count(*)': '0', 'sum(saldo_scrap)': '0', 'month': ''})
        result2.unshift({'count(*)': '0', 'sum(saldo_scrap)': '0', 'month': ''})
        result2.unshift({'count(*)': '0', 'sum(saldo_scrap)': '0', 'month': ''})


      }


      this.chartData = {
        labels: [
          result[0]["month"],
          result[1]["month"],
          result[2]["month"],
          result[3]["month"],
          result[4]["month"],
          result[5]["month"],
          result[6]["month"],
          result[7]["month"],
          result[8]["month"],
          result[9]["month"],
          result[10]["month"],

        ],
            datasets: [

          {
            label: 'Gutreifen',
            backgroundColor: '#17e132',
            data: []
          },

          {
                label: 'Schrottreifen',
                backgroundColor: '#fd0e3d',
                data: [result[0]["sum(saldo_scrap)"] / result[0]["count(*)"],result[1]["sum(saldo_scrap)"] / result[1]["count(*)"], result[2]["sum(saldo_scrap)"] / result[2]["count(*)"], result[3]["sum(saldo_scrap)"] / result[3]["count(*)"], result[4]["sum(saldo_scrap)"] / result[4]["count(*)"], result[5]["sum(saldo_scrap)"] / result[5]["count(*)"], result[6]["sum(saldo_scrap)"] / result[6]["count(*)"], result[7]["sum(saldo_scrap)"] / result[7]["count(*)"], result[8]["sum(saldo_scrap)"] / result[8]["count(*)"], result[9]["sum(saldo_scrap)"] / result[9]["count(*)"], result[10]["sum(saldo_scrap)"] / result[10]["count(*)"]]
          },

          {
                label: 'Stahl',
                backgroundColor: '#a16a21',
                data: [result1[0]["sum(saldo_scrap)"] / result1[0]["count(*)"],result1[1]["sum(saldo_scrap)"] / result1[1]["count(*)"], result1[2]["sum(saldo_scrap)"] / result1[2]["count(*)"], result1[3]["sum(saldo_scrap)"] / result1[3]["count(*)"], result1[4]["sum(saldo_scrap)"] / result1[4]["count(*)"], result1[5]["sum(saldo_scrap)"] / result1[5]["count(*)"], result1[6]["sum(saldo_scrap)"] / result1[6]["count(*)"], result1[7]["sum(saldo_scrap)"] / result1[7]["count(*)"], result1[8]["sum(saldo_scrap)"] / result1[8]["count(*)"], result1[9]["sum(saldo_scrap)"] / result1[9]["count(*)"], result1[10]["sum(saldo_scrap)"] / result1[10]["count(*)"]]
          },
          {
                label: 'Aluminium',
                backgroundColor: '#68686e',
                data: [result2[0]["sum(saldo_scrap)"] / result2[0]["count(*)"],result2[1]["sum(saldo_scrap)"] / result2[1]["count(*)"], result2[2]["sum(saldo_scrap)"] / result2[2]["count(*)"], result2[3]["sum(saldo_scrap)"] / result2[3]["count(*)"], result2[4]["sum(saldo_scrap)"] / result2[4]["count(*)"], result2[5]["sum(saldo_scrap)"] / result2[5]["count(*)"], result2[6]["sum(saldo_scrap)"] / result2[6]["count(*)"], result2[7]["sum(saldo_scrap)"] / result2[7]["count(*)"], result2[8]["sum(saldo_scrap)"] / result2[8]["count(*)"], result2[9]["sum(saldo_scrap)"] / result2[9]["count(*)"], result2[10]["sum(saldo_scrap)"] / result2[10]["count(*)"]]
          }

        ]
      }



      // Remove MyComponent from the DOM
      this.renderComponentLineChart = false;

      // Wait for the change to get flushed to the DOM
      await this.$nextTick();

      // Add the component back in
      this.renderComponentLineChart = true;


    },


    async calcStockNew(){

      // Einstellungen
      var param = {
        table: "stock_day",    // Tabellen Name
        statement: "custom",  // SELECT, INSERT, UPDATE, DELETE, CUSTOM
        type: "detail",       // detail, list (Bei SELECT) --> "detail" erfordert id, listfilter
        where: "true",
        selector: "",         // bei listflter -> id,name,test
        value: "",
        short: "false",       // Übermittlung nur von id
        debug: "false",       // Debug Ausgabe bei Select Abfrage
        // filter: "false",   // Bei true wird ein Feld gefiltert
        // filterfield: "",
        // filtervalue: "",
        // operator: "AND",   // AND für filterlist LIKE abfrage ()
        // Filter noch hinzufügen
        extension: "DELETE FROM stock_day"
      }

      // console.log(param.extension)

      // datetime >= "01-01-2009 00:00:00" and datetime <= now()

      // Daten -> Werden nur bei Insert oder Update gesendet
      var data = {
      }


      await this.$func.queryAPI(param, data)


      this.calcStock()

      this.overlay = true

      // await this.buildChart()

      this.overlay = false


    },



    async calcStock(){

      // Einstellungen
      var param = {
        table: "stock",    // Tabellen Name
        statement: "custom",  // SELECT, INSERT, UPDATE, DELETE, CUSTOM
        type: "detail",       // detail, list (Bei SELECT) --> "detail" erfordert id, listfilter
        where: "true",
        selector: "",         // bei listflter -> id,name,test
        value: "",
        short: "false",       // Übermittlung nur von id
        debug: "false",       // Debug Ausgabe bei Select Abfrage
        // filter: "false",   // Bei true wird ein Feld gefiltert
        // filterfield: "",
        // filtervalue: "",
        // operator: "AND",   // AND für filterlist LIKE abfrage ()
        // Filter noch hinzufügen
        extension: "SELECT date, date_timestamp, wasteno, SUM(weight), SUM(scrap_quantity_weight) FROM `stock` WHERE wasteno <> '' AND date_timestamp >= '2009-01-01' AND date_timestamp <= '" + this.$moment(Date.now()).format("YYYY-MM-DD") + "' GROUP BY date_timestamp, wasteno ORDER BY date_timestamp ASC" ,        // Erweiterung am Ende des SQL Befehls z.B. ORDER BY Colum ASC - Wird am Ende der SQL Abfrage hinzugefügt, bei CUSTOM entspricht das der gesamten Abfrage

      }

      // console.log(param.extension)

      // datetime >= "01-01-2009 00:00:00" and datetime <= now()

      // Daten -> Werden nur bei Insert oder Update gesendet
      var data = {
      }

      var result = await this.$func.queryAPI(param, data)


      var total = 0
      var total_scrap_160103 = 0
      var total_scrap_160117 = 0
      var total_scrap_160118 = 0
      var total_scrap = 0



      for (var i1 = 0; i1 < result.length; i1++) {


          if(Math.sign(result[i1]["SUM(weight)"]) == -1){
            total = Math.abs(total) - Math.abs(result[i1]["SUM(weight)"])
          }else{
            total = Math.abs(total) + Math.abs(result[i1]["SUM(weight)"])
          }


          if(result[i1]["SUM(scrap_quantity_weight)"] != ""){

          if(Math.sign(result[i1]["SUM(scrap_quantity_weight)"]) == -1){

            if(result[i1]["wasteno"] == "160103"){
              total_scrap_160103 = total_scrap_160103 - Math.abs(result[i1]["SUM(scrap_quantity_weight)"])
              total_scrap = total_scrap_160103
            }
            if(result[i1]["wasteno"] == "160117"){
              total_scrap_160117 = total_scrap_160117 - Math.abs(result[i1]["SUM(scrap_quantity_weight)"])
              total_scrap = total_scrap_160117
            }
            if(result[i1]["wasteno"] == "160118"){
              total_scrap_160118 = total_scrap_160118 - Math.abs(result[i1]["SUM(scrap_quantity_weight)"])
              total_scrap = total_scrap_160118
            }

          }else{
            if(result[i1]["wasteno"] == "160103"){
              total_scrap_160103 = total_scrap_160103 + Math.abs(result[i1]["SUM(scrap_quantity_weight)"])
              total_scrap = total_scrap_160103
            }
            if(result[i1]["wasteno"] == "160117"){
              total_scrap_160117 = total_scrap_160117 + Math.abs(result[i1]["SUM(scrap_quantity_weight)"])
              total_scrap = total_scrap_160117
            }
            if(result[i1]["wasteno"] == "160118"){
              total_scrap_160118 = total_scrap_160118 + Math.abs(result[i1]["SUM(scrap_quantity_weight)"])
              total_scrap = total_scrap_160118
            }
          }
          }


        await this.writeStockDate(result[i1]["date"], result[i1]["date_timestamp"], Number(result[i1]["SUM(weight)"]).toFixed(4), Number(total).toFixed(4), Number(total_scrap).toFixed(4), Number(result[i1]["SUM(scrap_quantity_weight)"]).toFixed(4), result[i1]["wasteno"])


      }




    },

    async writeStockDate(date, date_timestamp, saldo, total, saldo_scrap, total_scrap, wasteno){

      var month
      // this.translateMonth(this.$moment(date).subtract(2,'months').endOf('month').format('MMMM'))
      month = this.translateMonth(this.$moment(date, "DD.MM.YYYY").format('MMMM'))

      // Einstellungen
      var param = {
        table: "stock_day",    // Tabellen Name
        statement: "custom",  // SELECT, INSERT, UPDATE, DELETE, CUSTOM
        type: "detail",       // detail, list (Bei SELECT) --> "detail" erfordert id, listfilter
        where: "true",
        selector: "",         // bei listflter -> id,name,test
        value: "",
        short: "false",       // Übermittlung nur von id
        debug: "false",       // Debug Ausgabe bei Select Abfrage
        // filter: "false",   // Bei true wird ein Feld gefiltert
        // filterfield: "",
        // filtervalue: "",
        // operator: "AND",   // AND für filterlist LIKE abfrage ()
        // Filter noch hinzufügen
        extension: "INSERT INTO stock_day (date, date_timestamp, month, saldo, total, saldo_scrap, total_scrap, wasteno) VALUES ('" + date + "', '" + date_timestamp + "', '" + month + "', '0', '0', '" + saldo_scrap +  "', '" + total_scrap +  "', '" + wasteno +  "') ON DUPLICATE KEY UPDATE date = '" + date + "', wasteno = '" + wasteno + "'",        // Erweiterung am Ende des SQL Befehls z.B. ORDER BY Colum ASC - Wird am Ende der SQL Abfrage hinzugefügt, bei CUSTOM entspricht das der gesamten Abfrage
      }


      if (wasteno == "160118"){
        console.log(param.extension)
      }


      // Daten -> Werden nur bei Insert oder Update gesendet
      var data = {
      }

      await this.$func.queryAPI(param, data)

    },


    translateMonth(englishname){

      var output

      switch(englishname) {

        case "January":
          output = "Januar"
          break;

        case "February":
          output = "Februar"
          break;

        case "March":
          output = "März"
          break;

        case "April":
          output = "April"
          break;

        case "May":
          output = "Mai"
          break;

        case "June":
          output = "Juni"
          break;

        case "July":
          output = "Juli"
          break;

        case "August":
          output = "August"
          break;

        case "September":
          output = "September"
          break;

        case "October":
          output ="Oktober"
          break;

        case "November":
          output = "November"
          break;

        case "December":
          output = "Dezember"
          break;
      }


      return output



    },

    translateMonthEN(germanname){

      var output

      switch(germanname) {

        case "Januar":
          output = "January"
          break;

        case "Februar":
          output = "February"
          break;

        case "März":
          output = "March"
          break;

        case "April":
          output = "April"
          break;

        case "Mai":
          output = "May"
          break;

        case "Juni":
          output = "June"
          break;

        case "Juli":
          output = "July"
          break;

        case "August":
          output = "August"
          break;

        case "September":
          output = "September"
          break;

        case "Oktober":
          output ="October"
          break;

        case "November":
          output = "November"
          break;

        case "Dezember":
          output = "December"
          break;
      }


      return output



    },


    async getKWData(){
      console.log("getKWData")
      // trigger by button Abfrage
      // ToDo: add inventur values

      // wasteno: 160103
      // scrap_quantity_weight
      // good_quantity_weight

      const currentYear = this.cyear
      const startDate = `${currentYear}-01-01`

      this.selected_year = currentYear
      this.loadStockInventur(this.selected_year)

      // Set vales to 0
      this.total_weight_160103_good = 0
      this.total_weight_160103 = 0
      this.total_weight_160117 = 0
      this.total_weight_160118 = 0


      var days = this.getISOWeekDates(this.ckw, this.cyear)

      this.kw_date_start = this.$moment(days[0], "YYYY-MM-DD").format("DD.MM.YYYY")
      this.kw_date_end = this.$moment(days[6], "YYYY-MM-DD").format("DD.MM.YYYY")


      for (var i1 = 0; i1 < days.length; i1++) {
        console.log(this.$moment(days[i1], "YYYY-MM-DD").format("DD.MM.YYYY"))
        this.setReportDays(this.$moment(days[i1], "YYYY-MM-DD").format("DD.MM.YYYY"), i1)
      }


      // get scrap weight for the week
      var param = {
        table: this.table,    // Tabellen Name
        statement: "custom",  // SELECT, INSERT, UPDATE, DELETE, CUSTOM
        type: "detail",       // detail, list (Bei SELECT) --> "detail" erfordert id, listfilter
        where: "true",
        selector: "",         // bei listflter -> id,name,test
        value: "",
        short: "false",       // Übermittlung nur von id
        debug: "false",       // Debug Ausgabe bei Select Abfrage
        // filter: "false",   // Bei true wird ein Feld gefiltert
        // filterfield: "",
        // filtervalue: "",
        // operator: "AND",   // AND für filterlist LIKE abfrage ()
        // Filter noch hinzufügen
        extension: "SELECT SUM(scrap_quantity_weight) FROM `stock` WHERE wasteno='160103' AND (date_timestamp >= '" + days[0] + "' AND date_timestamp <= '" + days[6] + "')" ,
      }

      var data = {
      }

      var result = await this.$func.queryAPI(param, data)
      console.log(result)

      // this.exportStartValueScrapped
      // this.exportStartValueGood

      this.kw_total_scrap = Number(result[0]["SUM(scrap_quantity_weight)"]).toFixed(3)


      // get scrap weight for the year
       param = {
        table: this.table,
        statement: "custom",
        type: "detail",
        where: "true",
        selector: "",
        value: "",
        short: "false",
        debug: "false",
        extension: `SELECT SUM(scrap_quantity_weight) FROM \`stock\` WHERE wasteno='160103' AND (date_timestamp >= '${startDate}' AND date_timestamp <= '${days[6]}')`,
      }

      data = {
      }

      result = await this.$func.queryAPI(param, data)

      console.log(result)
      // this.year_total = Number(result[0]["SUM(scrap_quantity_weight)"]).toFixed(3) + this.exportStartValueScrapped
      this.year_total_scrap = Number((Number(result[0]["SUM(scrap_quantity_weight)"]) + Number(this.exportStartValueScrapped))).toFixed(3);



      this.kw_text = "KW " + this.ckw + " / " + this.cyear + "<br> " + this.kw_date_start + " - " + this.kw_date_end + " <br><b> Gesamt (Schrottreifen): " + Number(this.year_total_scrap).toLocaleString("de-DE") + " Tonnen</b><br><br> Zugang/Abgang (Schrottreifen): " + this.kw_total_scrap + " Tonnen"

    },



    
   async getKWDataForYear () {
      console.log('getKWDataForYear')
      
      
      this.isGenerating = true
      
      try {
        const year = Number(this.cyear) || new Date().getFullYear()
      const startDate = `${year}-01-01`
      const endDate   = `${year}-12-31`

      // Falls du Inventurwerte je Jahr lädst, hier belassen
      this.selected_year = year
      await this.loadStockInventur(this.selected_year)

      // Wochenanzahl (ISO) ermitteln: 52 oder 53
      const weeksInYear = this.$moment(`${year}-12-28`, 'YYYY-MM-DD').isoWeeksInYear()

      // Arrays vorbereiten
      const weekly = new Array(weeksInYear).fill(0)       // KW-Summen
      const cumulative = new Array(weeksInYear).fill(0)   // kumuliert
      const tooltips = new Array(weeksInYear).fill('')    // optionale Tooltip-Texte

      var kwTotalSchrott = 0
      var kwTotalGut = 0


      this.kwValues[0] = 0

      for (let i = 0; i < weeksInYear; i++) {

        var kw = i + 1

        var days = this.getISOWeekDates(kw, this.cyear)

        this.kw_date_start = this.$moment(days[0], "YYYY-MM-DD").format("DD.MM.YYYY")
        this.kw_date_end = this.$moment(days[6], "YYYY-MM-DD").format("DD.MM.YYYY")

        var param = {
          table: this.table,
          statement: "custom",
          type: "detail",
          where: "true",
          selector: "",
          value: "",
          short: "false",
          debug: "false",
          extension: `SELECT SUM(scrap_quantity_weight), SUM(good_quantity_weight) FROM \`stock\` WHERE wasteno='160103' AND (date_timestamp >= '${startDate}' AND date_timestamp <= '${days[6]}')`,
        }

        var data = {}

        var result = await this.$func.queryAPI(param, data)

        // console.log(result)
        kwTotalSchrott = Number((Number(result[0]["SUM(scrap_quantity_weight)"]) + Number(this.exportStartValueScrapped))).toFixed(3);
        kwTotalGut = Number((Number(result[0]["SUM(good_quantity_weight)"]) + Number(this.exportStartValueGood))).toFixed(3);

        console.log("KW " + kw + ": " + kwTotalSchrott)

        this.kwValuesSchrott[i] = kwTotalSchrott
        this.kwValuesGut[i] = kwTotalGut


      }
      console.log(this.kwValues)

      this.renderKwChart = true
      this.chartKey += 1

      } catch (error) {
        console.error("Error loading KW data:", error)
       
      } finally {
        
        this.isGenerating = false
      }
    },



    async createWochenreport() {
      this.isGeneratingReport = true;
      try {
        const stockData = await this.fetchStockData();
        console.log("---stock Data----:", stockData);

        const currentYear = this.cyear
        const startDate = `${currentYear}-01-01`

        this.selected_year = currentYear
        this.loadStockInventur(this.selected_year)

        var days = this.getISOWeekDates(this.ckw, this.cyear)

        this.kw_date_start = this.$moment(days[0], "YYYY-MM-DD").format("DD.MM.YYYY")
        this.kw_date_end = this.$moment(days[6], "YYYY-MM-DD").format("DD.MM.YYYY")

 

        var param = {
          vorlage_name: "wochenreport_with_style.png",
          pdf_autor: "Hüska GmbH",
          pdf_name: "temp.pdf",
          pdf_title: "Wochenreport",
          pdf_subject: "",
        }

    //      const weekDatesFormatted = [
    //   this.$moment(days[0], "YYYY-MM-DD").format("DD.MM"),  // Monday
    //   this.$moment(days[1], "YYYY-MM-DD").format("DD.MM"),  // Tuesday
    //   this.$moment(days[2], "YYYY-MM-DD").format("DD.MM"),  // Wednesday
    //   this.$moment(days[3], "YYYY-MM-DD").format("DD.MM"),  // Thursday
    //   this.$moment(days[4], "YYYY-MM-DD").format("DD.MM"),  // Friday
    //   this.$moment(days[5], "YYYY-MM-DD").format("DD.MM"),  // Saturday
    //   this.$moment(days[6], "YYYY-MM-DD").format("DD.MM")   // Sunday
    // ];

          const getDataForDate = (date) => {
          return stockData.find(item => item.date === date) || {};
        };

    const getWeekDates = () => {
        const dates = [];
        let startDate;
        if (this.kw_date_start && this.kw_date_start.includes('.')) {
          const parts = this.kw_date_start.split('.');
          startDate = new Date(parts[2], parts[1] - 1, parts[0]);
        } else if (this.kw_date_start && this.kw_date_start.includes('-')) {
          startDate = new Date(this.kw_date_start);
        } else {
          const today = new Date();
          const monday = new Date(today);
          monday.setDate(today.getDate() - (today.getDay() + 6) % 7);
          startDate = monday;
        }
        
        for (let i = 0; i < 7; i++) {
          const date = new Date(startDate);
          date.setDate(startDate.getDate() + i);
          const day = String(date.getDate()).padStart(2, '0');
          const month = String(date.getMonth() + 1).padStart(2, '0');
          const year = date.getFullYear();
          dates.push(`${day}.${month}.${year}`);
        }
        return dates;
      };

        const dates = getWeekDates();

    // Initialize totals
      let totalEingangGutreifen = 0, totalEingangSchrott = 0, totalEingangStahl = 0, 
          totalEingangAlu = 0, totalEingangSonstige = 0, totalEingangGesamt = 0;
      let totalAusgangGut = 0, totalAusgangSchrott = 0, totalAusgangStahl = 0, 
          totalAusgangAlu = 0, totalAusgangGesamt = 0;
      let lastBestandGut = 0, lastBestandSchrott = 0, lastBestandStahl = 0, 
          lastBestandAlu = 0, lastBestandGesamt = 0;

        // Calculate totals from stock data
        for (let dayIndex = 0; dayIndex < 7; dayIndex++) {
          const dayData = getDataForDate(dates[dayIndex]);

      
        totalEingangGutreifen += parseFloat(dayData['Eingang Gutreifen'] || 0);
        totalEingangSchrott += parseFloat(dayData['Eingang Schrott'] || 0);
        totalEingangStahl += parseFloat(dayData['Eingang Stahl'] || 0);
        totalEingangAlu += parseFloat(dayData['Eingang Alu'] || 0);
        totalEingangSonstige += parseFloat(dayData['Eingang Sonstige'] || 0);
        totalEingangGesamt += parseFloat(dayData['Eingang GESAMT'] || 0);
        
        totalAusgangGut += parseFloat(dayData['Ausgang Gut'] || 0);
        totalAusgangSchrott += parseFloat(dayData['Ausgang Schrott'] || 0);
        totalAusgangStahl += parseFloat(dayData['Ausgang Stahl'] || 0);
        totalAusgangAlu += parseFloat(dayData['Ausgang Alu'] || 0);
        totalAusgangGesamt += parseFloat(dayData['Ausgang GESAMT'] || 0);
        
      
          lastBestandGut = parseFloat(dayData['Bestand Gut'] || 0);
          lastBestandSchrott = parseFloat(dayData['Bestand Schrott'] || 0);
          lastBestandStahl = parseFloat(dayData['Bestand Stahl'] || 0);
          lastBestandAlu = parseFloat(dayData['Bestand Alu'] || 0);
          lastBestandGesamt = parseFloat(dayData['Bestand Schrott GESAMT'] || 0);
      
      }
        // column positions (x)
        const colPositions = {
          monday: 50,
          tuesday: 68,
          wednesday: 86,
          thursday: 104,
          friday: 122,
          saturday: 140,
          sunday: 158,
          total: 178
        };

        // row positions (y )
        const rowPositions = {

          eingang: {
            gutreifen: 102,
            schrott: 112,
            stahl: 122,
            alu: 132,
            sonstige: 140,
            gesamt: 148
          },

          ausgang: {
            gutreifen: 155,
            schrott: 165,
            stahl: 175,
            alu: 185,
            sonstige: 192,
            gesamt: 199
          },

          bestand: {
            gutreifen: 209,
            schrott: 219,
            stahl: 229,
            alu: 237,
            sonstige: 245,
            gesamt:252
          }
        };

        var data = {


          text: {


            0: {
              text: this.ckw + " / " + this.cyear,
              x: "56",
              y: "38",
            },
            1: {
              text: this.kw_date_start + " - " + this.kw_date_end,
              x: "56",
              y: "48",
            },
          // 300: { text: weekDatesFormatted[0], x: "50", y: "90"},   // Under "Mo."
          // 301: { text: weekDatesFormatted[1], x: "68", y: "90" },   // Under "Di."
          // 302: { text: weekDatesFormatted[2], x: "86", y: "90"},   // Under "Mi."
          // 303: { text: weekDatesFormatted[3], x: "104", y: "90",},  // Under "Do."
          // 304: { text: weekDatesFormatted[4], x: "122", y: "90" },  // Under "Fr."
          // 305: { text: weekDatesFormatted[5], x: "140", y: "90" },  // Under "Sa."
          // 306: { text: weekDatesFormatted[6], x: "158", y: "90" },  // Under "So."

          // EINGANG SECTION - Daily values
          // Monday 
          10: { text: await this.getDataForWeekReportDay(dates[0], "160103", "buy", "good"), x: colPositions.monday.toString(), y: rowPositions.eingang.gutreifen.toString() },
          11: { text: await this.getDataForWeekReportDay(dates[0], "160103", "buy", "scrap"), x: colPositions.monday.toString(), y: rowPositions.eingang.schrott.toString() },
          12: { text: await this.getDataForWeekReportDay(dates[0], "160118", "buy", "scrap"), x: colPositions.monday.toString(), y: rowPositions.eingang.stahl.toString() },
          13: { text: await this.getDataForWeekReportDay(dates[0], "160117", "buy", "scrap"), x: colPositions.monday.toString(), y: rowPositions.eingang.alu.toString() },
          14: { text: "0.00", x: colPositions.monday.toString(), y: rowPositions.eingang.sonstige.toString() },
          15: { text: await this.getDataForWeekReportDayTotal(dates[0], "buy"), x: colPositions.monday.toString(), y: rowPositions.eingang.gesamt.toString() },

          // Tuesday 
          16: { text: await this.getDataForWeekReportDay(dates[1], "160103", "buy", "good"), x: colPositions.tuesday.toString(), y: rowPositions.eingang.gutreifen.toString() },
          17: { text: await this.getDataForWeekReportDay(dates[1], "160103", "buy", "scrap"), x: colPositions.tuesday.toString(), y: rowPositions.eingang.schrott.toString() },
          18: { text: await this.getDataForWeekReportDay(dates[1], "160118", "buy", "scrap"), x: colPositions.tuesday.toString(), y: rowPositions.eingang.stahl.toString() },
          19: { text: await this.getDataForWeekReportDay(dates[1], "160117", "buy", "scrap"), x: colPositions.tuesday.toString(), y: rowPositions.eingang.alu.toString() },
          20: { text: "0.00", x: colPositions.tuesday.toString(), y: rowPositions.eingang.sonstige.toString() },
          21: { text: await this.getDataForWeekReportDayTotal(dates[1], "buy"), x: colPositions.tuesday.toString(), y: rowPositions.eingang.gesamt.toString() },
          
          // Wednesday
          22: { text: await this.getDataForWeekReportDay(dates[2], "160103", "buy", "good"), x: colPositions.wednesday.toString(), y: rowPositions.eingang.gutreifen.toString() },
          23: { text: await this.getDataForWeekReportDay(dates[2], "160103", "buy", "scrap"), x: colPositions.wednesday.toString(), y: rowPositions.eingang.schrott.toString() },
          24: { text: await this.getDataForWeekReportDay(dates[2], "160118", "buy", "scrap"), x: colPositions.wednesday.toString(), y: rowPositions.eingang.stahl.toString() },
          25: { text: await this.getDataForWeekReportDay(dates[2], "160117", "buy", "scrap"), x: colPositions.wednesday.toString(), y: rowPositions.eingang.alu.toString() },
          26: { text: "0.00", x: colPositions.wednesday.toString(), y: rowPositions.eingang.sonstige.toString() },
          27: { text: await this.getDataForWeekReportDayTotal(dates[2], "buy"), x: colPositions.wednesday.toString(), y: rowPositions.eingang.gesamt.toString() },
          
          // Thursday
          28: { text: await this.getDataForWeekReportDay(dates[3], "160103", "buy", "good"), x: colPositions.thursday.toString(), y: rowPositions.eingang.gutreifen.toString() },
          29: { text: await this.getDataForWeekReportDay(dates[3], "160103", "buy", "scrap"), x: colPositions.thursday.toString(), y: rowPositions.eingang.schrott.toString() },
          30: { text: await this.getDataForWeekReportDay(dates[3], "160118", "buy", "scrap"), x: colPositions.thursday.toString(), y: rowPositions.eingang.stahl.toString() },
          31: { text: await this.getDataForWeekReportDay(dates[3], "160117", "buy", "scrap"), x: colPositions.thursday.toString(), y: rowPositions.eingang.alu.toString() },
          32: { text: "0.00", x: colPositions.thursday.toString(), y: rowPositions.eingang.sonstige.toString() },
          33: { text: await this.getDataForWeekReportDayTotal(dates[3], "buy"), x: colPositions.thursday.toString(), y: rowPositions.eingang.gesamt.toString() },
          
          // Friday 
          34: { text: await this.getDataForWeekReportDay(dates[4], "160103", "buy", "good"), x: colPositions.friday.toString(), y: rowPositions.eingang.gutreifen.toString() },
          35: { text: await this.getDataForWeekReportDay(dates[4], "160103", "buy", "scrap"), x: colPositions.friday.toString(), y: rowPositions.eingang.schrott.toString() },
          36: { text: await this.getDataForWeekReportDay(dates[4], "160118", "buy", "scrap"), x: colPositions.friday.toString(), y: rowPositions.eingang.stahl.toString() },
          37: { text: await this.getDataForWeekReportDay(dates[4], "160117", "buy", "scrap"), x: colPositions.friday.toString(), y: rowPositions.eingang.alu.toString() },
          38: { text: "0.00", x: colPositions.friday.toString(), y: rowPositions.eingang.sonstige.toString() },
          39: { text: await this.getDataForWeekReportDayTotal(dates[4], "buy"), x: colPositions.friday.toString(), y: rowPositions.eingang.gesamt.toString() },
          
          // Saturday
          40: { text: await this.getDataForWeekReportDay(dates[5], "160103", "buy", "good"), x: colPositions.saturday.toString(), y: rowPositions.eingang.gutreifen.toString() },
          41: { text: await this.getDataForWeekReportDay(dates[5], "160103", "buy", "scrap"), x: colPositions.saturday.toString(), y: rowPositions.eingang.schrott.toString() },
          42: { text: await this.getDataForWeekReportDay(dates[5], "160118", "buy", "scrap"), x: colPositions.saturday.toString(), y: rowPositions.eingang.stahl.toString() },
          43: { text: await this.getDataForWeekReportDay(dates[5], "160117", "buy", "scrap"), x: colPositions.saturday.toString(), y: rowPositions.eingang.alu.toString() },
          44: { text: "0.00", x: colPositions.saturday.toString(), y: rowPositions.eingang.sonstige.toString() },
          45: { text: await this.getDataForWeekReportDayTotal(dates[5], "buy"), x: colPositions.saturday.toString(), y: rowPositions.eingang.gesamt.toString() },
          
          // Sunday
          46: { text: await this.getDataForWeekReportDay(dates[6], "160103", "buy", "good"), x: colPositions.sunday.toString(), y: rowPositions.eingang.gutreifen.toString() },
          47: { text: await this.getDataForWeekReportDay(dates[6], "160103", "buy", "scrap"), x: colPositions.sunday.toString(), y: rowPositions.eingang.schrott.toString() },
          48: { text: await this.getDataForWeekReportDay(dates[6], "160118", "buy", "scrap"), x: colPositions.sunday.toString(), y: rowPositions.eingang.stahl.toString() },
          49: { text: await this.getDataForWeekReportDay(dates[6], "160117", "buy", "scrap"), x: colPositions.sunday.toString(), y: rowPositions.eingang.alu.toString() },
          50: { text: "0.00", x: colPositions.sunday.toString(), y: rowPositions.eingang.sonstige.toString() },
          51: { text: await this.getDataForWeekReportDayTotal(dates[6], "buy"), x: colPositions.sunday.toString(), y: rowPositions.eingang.gesamt.toString() },
          
          // EINGANG TOTALS
          52: { text: await this.getDataForWeekReportWeekTotal(dates[0], dates[6], "160103", "buy", "good"), x: colPositions.total.toString(), y: rowPositions.eingang.gutreifen.toString() },
          53: { text: await this.getDataForWeekReportWeekTotal(dates[0], dates[6], "160103", "buy", "scrap"), x: colPositions.total.toString(), y: rowPositions.eingang.schrott.toString() },
          54: { text: await this.getDataForWeekReportWeekTotal(dates[0], dates[6], "160118", "buy", "scrap"), x: colPositions.total.toString(), y: rowPositions.eingang.stahl.toString() },
          55: { text: await this.getDataForWeekReportWeekTotal(dates[0], dates[6], "160117", "buy", "scrap"), x: colPositions.total.toString(), y: rowPositions.eingang.alu.toString() },
          56: { text: "0.00", x: colPositions.total.toString(), y: rowPositions.eingang.sonstige.toString() },
          57: { text: await this.getDataForWeekReportWeekTotal(dates[0], dates[6], "", "buy", "all"), x: colPositions.total.toString(), y: rowPositions.eingang.gesamt.toString() },




          // // AUSGANG SECTION 
    // Monday
          58: { text: await this.getDataForWeekReportDay(dates[0], "160103", "sell", "good"),  x: colPositions.monday.toString(),    y: rowPositions.ausgang.gutreifen.toString() },
          59: { text: await this.getDataForWeekReportDay(dates[0], "160103", "sell", "scrap"), x: colPositions.monday.toString(),    y: rowPositions.ausgang.schrott.toString() },
          60: { text: await this.getDataForWeekReportDay(dates[0], "160118", "sell", "scrap"), x: colPositions.monday.toString(),    y: rowPositions.ausgang.stahl.toString() },
          61: { text: await this.getDataForWeekReportDay(dates[0], "160117", "sell", "scrap"), x: colPositions.monday.toString(),    y: rowPositions.ausgang.alu.toString() },
          62: { text: "0.00", x: colPositions.monday.toString(), y: rowPositions.ausgang.sonstige.toString() },
          63: { text: await this.getDataForWeekReportDayTotal(dates[0], "sell"), x: colPositions.monday.toString(), y: rowPositions.ausgang.gesamt.toString() },

    // Tuesday
          64: { text: await this.getDataForWeekReportDay(dates[1], "160103", "sell", "good"),  x: colPositions.tuesday.toString(),   y: rowPositions.ausgang.gutreifen.toString() },
          65: { text: await this.getDataForWeekReportDay(dates[1], "160103", "sell", "scrap"), x: colPositions.tuesday.toString(),   y: rowPositions.ausgang.schrott.toString() },
          66: { text: await this.getDataForWeekReportDay(dates[1], "160118", "sell", "scrap"), x: colPositions.tuesday.toString(),   y: rowPositions.ausgang.stahl.toString() },
          67: { text: await this.getDataForWeekReportDay(dates[1], "160117", "sell", "scrap"), x: colPositions.tuesday.toString(),   y: rowPositions.ausgang.alu.toString() },
          68: { text: "0.00", x: colPositions.tuesday.toString(),y: rowPositions.ausgang.sonstige.toString() },
          69: { text: await this.getDataForWeekReportDayTotal(dates[1], "sell"), x: colPositions.tuesday.toString(),y: rowPositions.ausgang.gesamt.toString() },

    // Wednesday
          70: { text: await this.getDataForWeekReportDay(dates[2], "160103", "sell", "good"),  x: colPositions.wednesday.toString(), y: rowPositions.ausgang.gutreifen.toString() },
          71: { text: await this.getDataForWeekReportDay(dates[2], "160103", "sell", "scrap"), x: colPositions.wednesday.toString(), y: rowPositions.ausgang.schrott.toString() },
          72: { text: await this.getDataForWeekReportDay(dates[2], "160118", "sell", "scrap"), x: colPositions.wednesday.toString(), y: rowPositions.ausgang.stahl.toString() },
          73: { text: await this.getDataForWeekReportDay(dates[2], "160117", "sell", "scrap"), x: colPositions.wednesday.toString(), y: rowPositions.ausgang.alu.toString() },
          74: { text: "0.00", x: colPositions.wednesday.toString(),y: rowPositions.ausgang.sonstige.toString() },
          75: { text: await this.getDataForWeekReportDayTotal(dates[2], "sell"), x: colPositions.wednesday.toString(),y: rowPositions.ausgang.gesamt.toString() },

    // Thursday
          76: { text: await this.getDataForWeekReportDay(dates[3], "160103", "sell", "good"),  x: colPositions.thursday.toString(),  y: rowPositions.ausgang.gutreifen.toString() },
          77: { text: await this.getDataForWeekReportDay(dates[3], "160103", "sell", "scrap"), x: colPositions.thursday.toString(),  y: rowPositions.ausgang.schrott.toString() },
          78: { text: await this.getDataForWeekReportDay(dates[3], "160118", "sell", "scrap"), x: colPositions.thursday.toString(),  y: rowPositions.ausgang.stahl.toString() },
          79: { text: await this.getDataForWeekReportDay(dates[3], "160117", "sell", "scrap"), x: colPositions.thursday.toString(),  y: rowPositions.ausgang.alu.toString() },
          80: { text: "0.00", x: colPositions.thursday.toString(), y: rowPositions.ausgang.sonstige.toString() },
          81: { text: await this.getDataForWeekReportDayTotal(dates[3], "sell"), x: colPositions.thursday.toString(), y: rowPositions.ausgang.gesamt.toString() },

    // Friday
          82: { text: await this.getDataForWeekReportDay(dates[4], "160103", "sell", "good"),  x: colPositions.friday.toString(),    y: rowPositions.ausgang.gutreifen.toString() },
          83: { text: await this.getDataForWeekReportDay(dates[4], "160103", "sell", "scrap"), x: colPositions.friday.toString(),    y: rowPositions.ausgang.schrott.toString() },
          84: { text: await this.getDataForWeekReportDay(dates[4], "160118", "sell", "scrap"), x: colPositions.friday.toString(),    y: rowPositions.ausgang.stahl.toString() },
          85: { text: await this.getDataForWeekReportDay(dates[4], "160117", "sell", "scrap"), x: colPositions.friday.toString(),    y: rowPositions.ausgang.alu.toString() },
          86: { text: "0.00", x: colPositions.friday.toString(),  y: rowPositions.ausgang.sonstige.toString() },
          87: { text: await this.getDataForWeekReportDayTotal(dates[4], "sell"), x: colPositions.friday.toString(),  y: rowPositions.ausgang.gesamt.toString() },

    // Saturday
          88: { text: await this.getDataForWeekReportDay(dates[5], "160103", "sell", "good"),  x: colPositions.saturday.toString(),  y: rowPositions.ausgang.gutreifen.toString() },
          89: { text: await this.getDataForWeekReportDay(dates[5], "160103", "sell", "scrap"), x: colPositions.saturday.toString(),  y: rowPositions.ausgang.schrott.toString() },
          90: { text: await this.getDataForWeekReportDay(dates[5], "160118", "sell", "scrap"), x: colPositions.saturday.toString(),  y: rowPositions.ausgang.stahl.toString() },
          91: { text: await this.getDataForWeekReportDay(dates[5], "160117", "sell", "scrap"), x: colPositions.saturday.toString(),  y: rowPositions.ausgang.alu.toString() },
          92: { text: "0.00", x: colPositions.saturday.toString(), y: rowPositions.ausgang.sonstige.toString() },
          93: { text: await this.getDataForWeekReportDayTotal(dates[5], "sell"), x: colPositions.saturday.toString(), y: rowPositions.ausgang.gesamt.toString() },

    // Sunday
          94: { text: await this.getDataForWeekReportDay(dates[6], "160103", "sell", "good"),  x: colPositions.sunday.toString(),    y: rowPositions.ausgang.gutreifen.toString() },
          95: { text: await this.getDataForWeekReportDay(dates[6], "160103", "sell", "scrap"), x: colPositions.sunday.toString(),    y: rowPositions.ausgang.schrott.toString() },
          96: { text: await this.getDataForWeekReportDay(dates[6], "160118", "sell", "scrap"), x: colPositions.sunday.toString(),    y: rowPositions.ausgang.stahl.toString() },
          97: { text: await this.getDataForWeekReportDay(dates[6], "160117", "sell", "scrap"), x: colPositions.sunday.toString(),    y: rowPositions.ausgang.alu.toString() },
          98: { text: "0.00", x: colPositions.sunday.toString(),  y: rowPositions.ausgang.sonstige.toString() },
          99: { text: await this.getDataForWeekReportDayTotal(dates[6], "sell"), x: colPositions.sunday.toString(),  y: rowPositions.ausgang.gesamt.toString() },


    // AUSGANG TOTALS
          252: { text: await this.getDataForWeekReportWeekTotal(dates[0], dates[6], "160103", "sell_disposal", "good"), x: colPositions.total.toString(), y: rowPositions.ausgang.gutreifen.toString() },
          253: { text: await this.getDataForWeekReportWeekTotal(dates[0], dates[6], "160103", "sell_disposal", "scrap"), x: colPositions.total.toString(), y: rowPositions.ausgang.schrott.toString() },
          254: { text: await this.getDataForWeekReportWeekTotal(dates[0], dates[6], "160118", "sell_disposal", "scrap"), x: colPositions.total.toString(), y: rowPositions.ausgang.stahl.toString() },
          255: { text: await this.getDataForWeekReportWeekTotal(dates[0], dates[6], "160117", "sell_disposal", "scrap"), x: colPositions.total.toString(), y: rowPositions.ausgang.alu.toString() },
          256: { text: "0.00", x: colPositions.total.toString(), y: rowPositions.ausgang.sonstige.toString() },
          257: { text: await this.getDataForWeekReportWeekTotal(dates[0], dates[6], "", "sell_disposal", "all"), x: colPositions.total.toString(), y: rowPositions.ausgang.gesamt.toString() },






          // BESTAND SECTION
    // Monday
          100: { text: await this.getDataForWeekReportStock(dates[0], "160103", "good"),  x: colPositions.monday.toString(),    y: rowPositions.bestand.gutreifen.toString() },
          101: { text: await this.getDataForWeekReportStock(dates[0], "160103", "scrap"), x: colPositions.monday.toString(),    y: rowPositions.bestand.schrott.toString() },
          102: { text: await this.getDataForWeekReportStock(dates[0], "160118", "scrap"), x: colPositions.monday.toString(),    y: rowPositions.bestand.stahl.toString() },
          103: { text: await this.getDataForWeekReportStock(dates[0], "160117", "scrap"), x: colPositions.monday.toString(),    y: rowPositions.bestand.alu.toString() },
          104: { text: "0.00", x: colPositions.monday.toString(), y: rowPositions.bestand.sonstige.toString() },
        // 105: { text: await this.getDataForWeekReportStockTotal(dates[0]), x: colPositions.monday.toString(),  y: rowPositions.bestand.gesamt.toString() },



    // Tuesday
          106: { text: await this.getDataForWeekReportStock(dates[1], "160103", "good"),  x: colPositions.tuesday.toString(),   y: rowPositions.bestand.gutreifen.toString() },
          107: { text: await this.getDataForWeekReportStock(dates[1], "160103", "scrap"), x: colPositions.tuesday.toString(),   y: rowPositions.bestand.schrott.toString() },
          108: { text: await this.getDataForWeekReportStock(dates[1], "160118", "scrap"), x: colPositions.tuesday.toString(),   y: rowPositions.bestand.stahl.toString() },
          109: { text: await this.getDataForWeekReportStock(dates[1], "160117", "scrap"), x: colPositions.tuesday.toString(),   y: rowPositions.bestand.alu.toString() },
          110: { text: "0.00", x: colPositions.tuesday.toString(), y: rowPositions.bestand.sonstige.toString() },
        //  111: { text: await this.getDataForWeekReportStockTotal(dates[1]), x: colPositions.tuesday.toString(),  y: rowPositions.bestand.gesamt.toString() },

    // Wednesday
          112: { text: await this.getDataForWeekReportStock(dates[2], "160103", "good"),  x: colPositions.wednesday.toString(), y: rowPositions.bestand.gutreifen.toString() },
          113: { text: await this.getDataForWeekReportStock(dates[2], "160103", "scrap"), x: colPositions.wednesday.toString(), y: rowPositions.bestand.schrott.toString() },
          114: { text: await this.getDataForWeekReportStock(dates[2], "160118", "scrap"), x: colPositions.wednesday.toString(), y: rowPositions.bestand.stahl.toString() },
          115: { text: await this.getDataForWeekReportStock(dates[2], "160117", "scrap"), x: colPositions.wednesday.toString(), y: rowPositions.bestand.alu.toString() },
          116: { text: "0.00", x: colPositions.wednesday.toString(), y: rowPositions.bestand.sonstige.toString() },
        //  117: { text: await this.getDataForWeekReportStockTotal(dates[2]), x: colPositions.wednesday.toString(),  y: rowPositions.bestand.gesamt.toString() },


    // Thursday
          118: { text: await this.getDataForWeekReportStock(dates[3], "160103", "good"),  x: colPositions.thursday.toString(),  y: rowPositions.bestand.gutreifen.toString() },
          119: { text: await this.getDataForWeekReportStock(dates[3], "160103", "scrap"), x: colPositions.thursday.toString(),  y: rowPositions.bestand.schrott.toString() },
          120: { text: await this.getDataForWeekReportStock(dates[3], "160118", "scrap"), x: colPositions.thursday.toString(),  y: rowPositions.bestand.stahl.toString() },
          121: { text: await this.getDataForWeekReportStock(dates[3], "160117", "scrap"), x: colPositions.thursday.toString(),  y: rowPositions.bestand.alu.toString() },
          122: { text: "0.00", x: colPositions.thursday.toString(), y: rowPositions.bestand.sonstige.toString() },
        // 123: { text: await this.getDataForWeekReportStockTotal(dates[3]), x: colPositions.thursday.toString(),  y: rowPositions.bestand.gesamt.toString() },

    // Friday
          124: { text: await this.getDataForWeekReportStock(dates[4], "160103", "good"),  x: colPositions.friday.toString(),    y: rowPositions.bestand.gutreifen.toString() },
          125: { text: await this.getDataForWeekReportStock(dates[4], "160103", "scrap"), x: colPositions.friday.toString(),    y: rowPositions.bestand.schrott.toString() },
          126: { text: await this.getDataForWeekReportStock(dates[4], "160118", "scrap"), x: colPositions.friday.toString(),    y: rowPositions.bestand.stahl.toString() },
          127: { text: await this.getDataForWeekReportStock(dates[4], "160117", "scrap"), x: colPositions.friday.toString(),    y: rowPositions.bestand.alu.toString() },
          128: { text: "0.00", x: colPositions.friday.toString(), y: rowPositions.bestand.sonstige.toString() },
        // 129: { text: await this.getDataForWeekReportStockTotal(dates[4]), x: colPositions.friday.toString(),  y: rowPositions.bestand.gesamt.toString() },

    // Saturday
          130: { text: await this.getDataForWeekReportStock(dates[5], "160103", "good"),  x: colPositions.saturday.toString(),  y: rowPositions.bestand.gutreifen.toString() },
          131: { text: await this.getDataForWeekReportStock(dates[5], "160103", "scrap"), x: colPositions.saturday.toString(),  y: rowPositions.bestand.schrott.toString() },
          132: { text: await this.getDataForWeekReportStock(dates[5], "160118", "scrap"), x: colPositions.saturday.toString(),  y: rowPositions.bestand.stahl.toString() },
          133: { text: await this.getDataForWeekReportStock(dates[5], "160117", "scrap"), x: colPositions.saturday.toString(),  y: rowPositions.bestand.alu.toString() },
          134: { text: "0.00", x: colPositions.saturday.toString(), y: rowPositions.bestand.sonstige.toString() },
        //  135: { text: await this.getDataForWeekReportStockTotal(dates[5]), x: colPositions.saturday.toString(),  y: rowPositions.bestand.gesamt.toString() },

    // Sunday
          136: { text: await this.getDataForWeekReportStock(dates[6], "160103", "good"),  x: colPositions.sunday.toString(),    y: rowPositions.bestand.gutreifen.toString() },
          137: { text: await this.getDataForWeekReportStock(dates[6], "160103", "scrap"), x: colPositions.sunday.toString(),    y: rowPositions.bestand.schrott.toString() },
          138: { text: await this.getDataForWeekReportStock(dates[6], "160118", "scrap"), x: colPositions.sunday.toString(),    y: rowPositions.bestand.stahl.toString() },
          139: { text: await this.getDataForWeekReportStock(dates[6], "160117", "scrap"), x: colPositions.sunday.toString(),    y: rowPositions.bestand.alu.toString() },
          140: { text: "0.00", x: colPositions.sunday.toString(), y: rowPositions.bestand.sonstige.toString() },
        //  141: { text: await this.getDataForWeekReportStockTotal(dates[6]), x: colPositions.sunday.toString(),  y: rowPositions.bestand.gesamt.toString() },





          // AUSGANG TOTALS (GESAMT column)
          // 58: { text: totalAusgangGut.toFixed(1), x: colPositions.total.toString(), y: rowPositions.ausgang.gut.toString() },
          // 59: { text: totalAusgangSchrott.toFixed(1), x: colPositions.total.toString(), y: rowPositions.ausgang.schrott.toString() },
          // 60: { text: totalAusgangStahl.toFixed(1), x: colPositions.total.toString(), y: rowPositions.ausgang.stahl.toString() },
          // 61: { text: totalAusgangAlu.toFixed(1), x: colPositions.total.toString(), y: rowPositions.ausgang.alu.toString() },
          // 62: { text: totalAusgangGesamt.toFixed(1), x: colPositions.total.toString(), y: rowPositions.ausgang.gesamt.toString() },
          
          // // BESTAND 
          // 63: { text: lastBestandGut.toFixed(1), x: colPositions.total.toString(), y: rowPositions.bestand.gut.toString() },
          // 64: { text: lastBestandSchrott.toFixed(1), x: colPositions.total.toString(), y: rowPositions.bestand.schrott.toString() },
          // 65: { text: lastBestandStahl.toFixed(1), x: colPositions.total.toString(), y: rowPositions.bestand.stahl.toString() },
          // 66: { text: lastBestandAlu.toFixed(1), x: colPositions.total.toString(), y: rowPositions.bestand.alu.toString() },
          // 67: { text: lastBestandGesamt.toFixed(1), x: colPositions.total.toString(), y: rowPositions.bestand.gesamt.toString() },
        },
        image: {
          0: {
            name: "",
            x: "5",
            y: "5",
            w: "1",
            h: "1",
          },
        },
      }
        console.log("ARRAY !!!!!!!!!!!!!!!!!!!!!!!!")
      console.log(this.getDataForWeekReportWeekTotal(dates[0], dates[6], "160103", "buy", "good"))

        console.log(data)
        // Param- und Data-Objekte in JSON kodieren
        const payload = {
          param: param,   // JSON-Objekte direkt senden
          data: data
        }

        const config = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' }, // JSON-Header
          responseType: 'blob' // Wir erwarten ein PDF (Binary)
      }

        const response = await Vue.prototype.$axios.post(
          Vue.prototype.$api_pdf_endpoint,
          payload,
          config
        )

        // PDF aus Blob erzeugen
        const blob = new Blob([response.data], { type: 'application/pdf' })
        const url = window.URL.createObjectURL(blob)

        // Neues Fenster mit PDF öffnen
        window.open(url)
      } catch (error) {
        console.error("Fehler beim Erstellen des PDFs:", error);
      } finally {
        this.isGeneratingReport = false;
      }
    },

    // async createWochenreport() {
    //   const stockData = await this.fetchStockData();
    //   console.log("stock Data:", stockData);
      
    //   var param = {
    //     vorlage_name: "wochenreport_with_style.png", 
    //     pdf_autor: "Hüska GmbH",
    //     pdf_name: "temp.pdf",
    //     pdf_title: "Wochenreport",
    //     pdf_subject: "",
    //   }

    //   const getDataForDate = (date) => {
    //     return stockData.find(item => item.date === date) || {};
    //   };

    //   const getWeekDates = () => {
    //     const dates = [];
    //     let startDate;
    //     if (this.kw_date_start && this.kw_date_start.includes('.')) {
    //       const parts = this.kw_date_start.split('.');
    //       startDate = new Date(parts[2], parts[1] - 1, parts[0]);
    //     } else if (this.kw_date_start && this.kw_date_start.includes('-')) {
    //       startDate = new Date(this.kw_date_start);
    //     } else {
    //       const today = new Date();
    //       const monday = new Date(today);
    //       monday.setDate(today.getDate() - (today.getDay() + 6) % 7);
    //       startDate = monday;
    //     }
        
    //     for (let i = 0; i < 7; i++) {
    //       const date = new Date(startDate);
    //       date.setDate(startDate.getDate() + i);
    //       const day = String(date.getDate()).padStart(2, '0');
    //       const month = String(date.getMonth() + 1).padStart(2, '0');
    //       const year = date.getFullYear();
    //       dates.push(`${day}.${month}.${year}`);
    //     }
    //     return dates;
    //   };

    //   const dates = getWeekDates();
      
    //   // Column positions (x coordinates)
    //   const colPositions = [45, 65, 83, 102, 121, 138, 157]; // Mon-Sun
    //   const totalColPosition = 178;

    //   // Row positions for different sections
    //   const rowPositions = {
    //     eingang: {
    //       gutreifen: 120,
    //       schrott: 127,
    //       stahl: 134,
    //       alu: 141,
    //       sonstige: 148,
    //       gesamt: 154
    //     },
    //     ausgang: {
    //       gut: 161,
    //       schrott: 170,
    //       stahl: 180,
    //       alu: 190,
    //       gesamt: 198
    //     },
    //     bestand: {
    //       gut: 210,
    //       schrott: 220,
    //       stahl: 230,
    //       alu: 240,
    //       gesamt: 245
    //     }
    //   };

    //   // Categories configuration
    //   const categories = {
    //     eingang: [
    //       { key: 'Eingang Gutreifen', row: rowPositions.eingang.gutreifen },
    //       { key: 'Eingang Schrott', row: rowPositions.eingang.schrott },
    //       { key: 'Eingang Stahl', row: rowPositions.eingang.stahl },
    //       { key: 'Eingang Alu', row: rowPositions.eingang.alu },
    //       { key: 'Eingang Sonstige', row: rowPositions.eingang.sonstige },
    //       { key: 'Eingang GESAMT', row: rowPositions.eingang.gesamt }
    //     ],
    //     ausgang: [
    //       { key: 'Ausgang Gut', row: rowPositions.ausgang.gut },
    //       { key: 'Ausgang Schrott', row: rowPositions.ausgang.schrott },
    //       { key: 'Ausgang Stahl', row: rowPositions.ausgang.stahl },
    //       { key: 'Ausgang Alu', row: rowPositions.ausgang.alu },
    //       { key: 'Ausgang GESAMT', row: rowPositions.ausgang.gesamt }
    //     ],
    //     bestand: [
    //       { key: 'Bestand Gut', row: rowPositions.bestand.gut },
    //       { key: 'Bestand Schrott', row: rowPositions.bestand.schrott },
    //       { key: 'Bestand Stahl', row: rowPositions.bestand.stahl },
    //       { key: 'Bestand Alu', row: rowPositions.bestand.alu },
    //       { key: 'Bestand Schrott GESAMT', row: rowPositions.bestand.gesamt }
    //     ]
    //   };

    //   // Calculate totals
    //   const totals = {};
      
    //   // Initialize totals for each category
    //   Object.keys(categories).forEach(section => {
    //     totals[section] = {};
    //     categories[section].forEach(cat => {
    //       totals[section][cat.key] = 0;
    //     });
    //   });

    //   // Calculate totals from stock data
    //   for (let dayIndex = 0; dayIndex < 7; dayIndex++) {
    //     const dayData = getDataForDate(dates[dayIndex]);
        
    //     // Sum up eingang and ausgang values
    //     ['eingang', 'ausgang'].forEach(section => {
    //       categories[section].forEach(cat => {
    //         totals[section][cat.key] += parseFloat(dayData[cat.key] || 0);
    //       });
    //     });
    //   }

    //   // For bestand, use the last day's values
    //   const lastDayData = getDataForDate(dates[6]); // Sunday
    //   categories.bestand.forEach(cat => {
    //     totals.bestand[cat.key] = parseFloat(lastDayData[cat.key] || 0);
    //   });

    //   // Build data object dynamically
    //   var data = {
    //     text: {
    //       // Header information
    //       0: {
    //         text: this.ckw + " / " + this.cyear,
    //         x: "56",
    //         y: "38",
    //       },
    //       1: {
    //         text: this.kw_date_start + " - " + this.kw_date_end,
    //         x: "56",
    //         y: "48",
    //       },
    //       2: {
    //         text: "160103",
    //         x: "75",
    //         y: "60",
    //       }
    //     },
    //     image: {
    //       0: {
    //         name: "",
    //         x: "5",
    //         y: "5",
    //         w: "1",
    //         h: "1",
    //       },
    //     },
    //   };

    //   let textIndex = 10; // Start from index 10 for data entries

    //   // Generate daily values and totals for each section
    //   Object.keys(categories).forEach(sectionName => {
    //     const section = categories[sectionName];
        
    //     section.forEach(category => {
    //       // Daily values for each day of the week
    //      // bestand only shows totals, not daily values
    //         for (let dayIndex = 0; dayIndex < 7; dayIndex++) {
    //           const dayData = getDataForDate(dates[dayIndex]);
    //           const value = parseFloat(dayData[category.key] || 0);
              
    //           data.text[textIndex] = {
    //             text: value.toFixed(1),
    //             x: colPositions[dayIndex].toString(),
    //             y: category.row.toString()
    //           };
    //           textIndex++;
            
    //       }
          
    //       // Total column
    //       data.text[textIndex] = {
    //         text: totals[sectionName][category.key].toFixed(1),
    //         x: totalColPosition.toString(),
    //         y: category.row.toString()
    //       };
    //       textIndex++;
    //     });
    //   });

    //   // Create request
    //   var request = "param=" + encodeURIComponent(JSON.stringify(param)) + "&data=" + encodeURIComponent(JSON.stringify(data));
    //   console.log(Vue.prototype.$api_pdf_endpoint + "?" + request);

    //   try {
    //     const response = await Vue.prototype.$axios.post(
    //       Vue.prototype.$api_pdf_endpoint,
    //       {
    //         param: param,
    //         data: data
    //       },
    //       {
    //         responseType: 'blob'
    //       }
    //     );
        
    //     let blob = new Blob([response.data], { type: 'application/pdf' });
    //     let url = window.URL.createObjectURL(blob);
    //     window.open(url);
    //     return {"status": "200"};
    //   } catch (error) {
    //     console.error('Error generating PDF:', error);
    //     return {"status": "404"};
    //   }
    // },
    // Helper function to get dates for each day of the week
    getWeekDates() {
      const dates = [];
      const startDate = new Date(this.kw_date_start.split('.').reverse().join('-'));
      
      for (let i = 0; i < 7; i++) {
        const date = new Date(startDate);
        date.setDate(startDate.getDate() + i);
        dates.push(date.toLocaleDateString('de-DE')); 
      }
      
      return dates;
    },

    async fetchStockData() {
      try {
        console.log("dates:", this.kw_date_start, this.kw_date_end);
        
        
        function formatDateForSQL(dateString) {
          if (!dateString) return null;
          
          
          let parts;
          let sqlDate;
          
          
          if (dateString.match(/^\d{4}-\d{2}-\d{2}$/)) {
            return dateString;
          }
          
          
          if (dateString.includes('.')) {
            parts = dateString.split('.');
            if (parts.length === 3) {
              const day = parts[0].padStart(2, '0');
              const month = parts[1].padStart(2, '0');
              const year = parts[2];
              sqlDate = `${year}-${month}-${day}`;
            }
          }
        
          else if (dateString.includes('/')) {
            parts = dateString.split('/');
            if (parts.length === 3) {
              const day = parts[0].padStart(2, '0');
              const month = parts[1].padStart(2, '0');
              const year = parts[2];
              sqlDate = `${year}-${month}-${day}`;
            }
          }
          
          else if (dateString.includes('-') && dateString.split('-')[0].length <= 2) {
            parts = dateString.split('-');
            if (parts.length === 3) {
              const day = parts[0].padStart(2, '0');
              const month = parts[1].padStart(2, '0');
              const year = parts[2];
              sqlDate = `${year}-${month}-${day}`;
            }
          }
          
          
          if (sqlDate) {
            const testDate = new Date(sqlDate);
            if (!isNaN(testDate.getTime())) {
              return sqlDate;
            }
          }
          
          console.warn("Could not parse date:", dateString);
          return null;
        }
        
        const sqlStartDate = formatDateForSQL(this.kw_date_start);
        const sqlEndDate = formatDateForSQL(this.kw_date_end);
        
        // If we couldn't parse the dates, use fallback or current week
        if (!sqlStartDate || !sqlEndDate) {
          console.error("Date parsing failed. Original dates:", this.kw_date_start, this.kw_date_end);
          
          
          const today = new Date();
          const monday = new Date(today);
          monday.setDate(today.getDate() - (today.getDay() + 6) % 7);
          const sunday = new Date(monday);
          sunday.setDate(monday.getDate() + 6);
          
          const fallbackStart = monday.toISOString().split('T')[0];
          const fallbackEnd = sunday.toISOString().split('T')[0];
          
          console.log("Using fallback dates:", fallbackStart, fallbackEnd);
          return this.fetchStockDataWithDates(fallbackStart, fallbackEnd);
        }
        
        console.log("Formatted dates:", sqlStartDate, sqlEndDate);
        
        return this.fetchStockDataWithDates(sqlStartDate, sqlEndDate);
        
      } catch (error) {
        console.error("Error in fetchStockData:", error);
        return [];
      }
    },
    async fetchStockDataWithDates(sqlStartDate, sqlEndDate) {
      try {
        
        const dateSelect = "DATE_FORMAT(date_timestamp, '%d.%m.%Y') as date";
        const groupBy = "GROUP BY DATE(date_timestamp)";
        
        const param = {
          table: 'stock',
          statement: "custom",
          type: "detail",
          where: "true",
          selector: "",
          value: "",
          short: "false",
          debug: "true",
          extension: `SELECT ${dateSelect}, ` +
          // Eingang (Incoming)
          "ROUND(SUM(CASE WHEN typ = 'buy' AND wasteno = '160103' " + 
          "THEN COALESCE(CAST(good_quantity_weight AS DECIMAL(10,3)), weight) ELSE 0 END), 3) AS 'Eingang Gutreifen', " + 
          "ROUND(SUM(CASE WHEN typ = 'buy' AND wasteno = '160103' THEN COALESCE(scrap_quantity_weight, 0) ELSE 0 END), 3) AS 'Eingang Schrott', " +
          "ROUND(SUM(CASE WHEN typ = 'buy' AND wasteno = '160117' THEN weight ELSE 0 END), 3) AS 'Eingang Stahl', " +
          "ROUND(SUM(CASE WHEN typ = 'buy' AND wasteno = '160118' THEN weight ELSE 0 END), 3) AS 'Eingang Alu', " +
          "ROUND(SUM(CASE WHEN typ = 'buy' AND wasteno NOT IN ('160103', '160117', '160118') THEN weight ELSE 0 END), 3) AS 'Eingang Sonstige', " +
          "ROUND(SUM(CASE WHEN typ = 'buy' THEN weight ELSE 0 END), 3) AS 'Eingang GESAMT', " +
          // Ausgang (Outgoing)
          "ROUND(SUM(CASE WHEN (typ = 'sell' OR typ = 'disposal') AND wasteno = '160103' THEN COALESCE(good_quantity_weight, weight) ELSE 0 END), 3) AS 'Ausgang Gut'," +
          "ROUND(SUM(CASE WHEN (typ = 'sell' OR typ = 'disposal') AND wasteno = '160103' THEN COALESCE(scrap_quantity_weight, 0) ELSE 0 END), 3) AS 'Ausgang Schrott'," +
          "ROUND(SUM(CASE WHEN (typ = 'sell' OR typ = 'disposal') AND wasteno = '160117' THEN weight ELSE 0 END), 3) AS 'Ausgang Stahl', " +
          "ROUND(SUM(CASE WHEN (typ = 'sell' OR typ = 'disposal') AND wasteno = '160118' THEN weight ELSE 0 END), 3) AS 'Ausgang Alu', " +
          "ROUND(SUM(CASE WHEN typ = 'sell' OR typ = 'disposal' THEN weight ELSE 0 END), 3) AS 'Ausgang GESAMT', " +
          // Bestand (Stock) 
          "ROUND((SELECT COALESCE(SUM(CASE " +
          "WHEN t2.typ = 'buy' AND t2.wasteno = '160103' " +
          "THEN COALESCE(CAST(t2.good_quantity_weight AS DECIMAL(10,3)), t2.weight) " +
          "WHEN (t2.typ = 'sell' OR t2.typ = 'disposal') AND t2.wasteno = '160103' " +
          "THEN -ABS(COALESCE(t2.good_quantity_weight, t2.weight)) " +
          "ELSE 0 END), 0) " +
          "FROM stock t2 " +
          "WHERE t2.date_timestamp <= stock.date_timestamp " +
          "AND t2.date_timestamp >= DATE_SUB('" + sqlStartDate + "', INTERVAL 30 DAY)), 3) AS 'Bestand Gut', " +
          "ROUND((SELECT COALESCE(SUM(CASE " +
          "WHEN t2.typ = 'buy' AND t2.wasteno = '160103' " +
          "THEN COALESCE(t2.scrap_quantity_weight, 0) " +
          "WHEN t2.typ = 'disposal' AND t2.wasteno = '160103' " +
          "THEN -ABS(COALESCE(t2.scrap_quantity_weight, 0)) " +
          "ELSE 0 END), 0) " +
          "FROM stock t2 " +
          "WHERE t2.date_timestamp <= stock.date_timestamp " +
          "AND t2.date_timestamp >= DATE_SUB('" + sqlStartDate + "', INTERVAL 30 DAY)), 3) AS 'Bestand Schrott', " +
          "ROUND((SELECT COALESCE(SUM(CASE " +
          "WHEN t2.typ = 'buy' AND t2.wasteno = '160117' " +
          "THEN t2.weight " +
          "WHEN t2.typ IN ('sell', 'disposal') AND t2.wasteno = '160117' " +
          "THEN -ABS(t2.weight) " +
          "ELSE 0 END), 0) " +
          "FROM stock t2 " +
          "WHERE t2.date_timestamp <= stock.date_timestamp " +
          "AND t2.date_timestamp >= DATE_SUB('" + sqlStartDate + "', INTERVAL 30 DAY)), 3) AS 'Bestand Stahl', " +
          "ROUND((SELECT COALESCE(SUM(CASE " +
          "WHEN t2.typ = 'buy' AND t2.wasteno = '160118' " +
          "THEN t2.weight " +
          "WHEN t2.typ IN ('sell', 'disposal') AND t2.wasteno = '160118' " +
          "THEN -ABS(t2.weight) " +
          "ELSE 0 END), 0) " +
          "FROM stock t2 " +
          "WHERE t2.date_timestamp <= stock.date_timestamp " +
          "AND t2.date_timestamp >= DATE_SUB('" + sqlStartDate + "', INTERVAL 30 DAY)), 3) AS 'Bestand Alu', " +
          // Bestand SCHROTT GESAMT
          "ROUND((SELECT COALESCE(SUM(CASE " +
          "WHEN (t2.typ = 'buy' AND t2.wasteno = '160103') THEN COALESCE(t2.scrap_quantity_weight, 0) " +
          "WHEN (t2.typ = 'buy' AND t2.wasteno IN ('160117', '160118')) THEN t2.weight " +
          "WHEN (t2.typ = 'buy' AND t2.wasteno NOT IN ('160103', '160117', '160118')) THEN t2.weight " +
          "WHEN (t2.typ = 'disposal' AND t2.wasteno = '160103') THEN -ABS(COALESCE(t2.scrap_quantity_weight, 0)) " +
          "WHEN (t2.typ IN ('sell', 'disposal') AND t2.wasteno IN ('160117', '160118')) THEN -ABS(t2.weight) " +
          "WHEN (t2.typ IN ('sell', 'disposal') AND t2.wasteno NOT IN ('160103', '160117', '160118')) THEN -ABS(t2.weight) " +
          "ELSE 0 END), 0) " +
          "FROM stock t2 " +
          "WHERE t2.date_timestamp <= stock.date_timestamp " +
          "AND t2.date_timestamp >= DATE_SUB('" + sqlStartDate + "', INTERVAL 30 DAY)), 3) AS 'Bestand Schrott GESAMT' " +
          "FROM stock " +
          "WHERE (DATE(date_timestamp) >= DATE('" + sqlStartDate + "') AND DATE(date_timestamp) <= DATE('" + sqlEndDate + "')) " +
          `${groupBy} ` +
          "ORDER BY DATE(date_timestamp) ASC"
        };
        console.log("SQL Query being executed:", param.extension);
        const response = await this.$axios.get(this.$api_endpoint, { params: param });
        console.log("Stock data fetched:", response.data);
        return response.data || [];
      } catch (error) {
        console.error("Error fetching stock data with dates:", error);
        return [];
      }
    },

    // async getDataForWeekReportDay(date, wasteno, typ, quantity_typ){
    //   console.log("getDataForWeekReportDay")

    //   // Einstellungen
    //   var param = {
    //     table: "",            // Tabellen Name
    //     statement: "custom",  // SELECT, INSERT, UPDATE, DELETE, CUSTOM
    //     type: "detail",       // detail, list (Bei SELECT) --> "detail" erfordert id, listfilter
    //     where: "true",
    //     selector: "",         // bei listflter -> id,name,test
    //     value: "",
    //     short: "false",       // Übermittlung nur von id
    //     debug: "false",       // Debug Ausgabe bei Select Abfrage
    //     // filter: "false",   // Bei true wird ein Feld gefiltert
    //     // filterfield: "",
    //     // filtervalue: "",
    //     // operator: "AND",   // AND für filterlist LIKE abfrage ()
    //     // Filter noch hinzufügen
    //     extension: "SELECT SUM(good_quantity_weight), SUM(scrap_quantity_weight) FROM `stock` WHERE date = '" + date + "' AND wasteno = '" + wasteno + "' AND typ = '" + typ + "'" ,        // Erweiterung am Ende des SQL Befehls z.B. ORDER BY Colum ASC - Wird am Ende der SQL Abfrage hinzugefügt, bei CUSTOM entspricht das der gesamten Abfrage
    //   }

    //   console.log(param.extension)

    //   // datetime >= "01-01-2009 00:00:00" and datetime <= now()

    //   // Daten -> Werden nur bei Insert oder Update gesendet
    //   var data = {
    //   }

    //   var result = await this.$func.queryAPI(param, data)

    //   console.log(result[0]["SUM(good_quantity_weight)"] || 0.00, result[0]["SUM(scrap_quantity_weight)"] || 0.00)


    //   if(quantity_typ == "good"){
    //     return Number(result[0]["SUM(good_quantity_weight)"]).toFixed(2) || 0.00
    //   } else if(quantity_typ == "scrap"){
    //     return Number(result[0]["SUM(scrap_quantity_weight)"]).toFixed(2) || 0.00
    //   } else {
    //     return "0.00"
    //   }

    // },



    async getDataForWeekReportDay(date, wasteno, typ, quantity_typ){
      console.log("getDataForWeekReportDay")

      // Build the typ condition - for 'sell', include both 'sell' and 'disposal'
      let typCondition = "";
      if (typ === 'sell') {
        typCondition = "AND (typ = 'sell' OR typ = 'disposal')";
      } else if (typ === 'buy') {
        typCondition = "AND typ = 'buy'";
      } else {
        typCondition = "AND typ = '" + typ + "'";
      }

      // Einstellungen
      var param = {
        table: "",            // Tabellen Name
        statement: "custom",  // SELECT, INSERT, UPDATE, DELETE, CUSTOM
        type: "detail",       // detail, list (Bei SELECT) --> "detail" erfordert id, listfilter
        where: "true",
        selector: "",         // bei listflter -> id,name,test
        value: "",
        short: "false",       // Übermittlung nur von id
        debug: "false",       // Debug Ausgabe bei Select Abfrage
        extension: "SELECT SUM(good_quantity_weight), SUM(scrap_quantity_weight), SUM(weight) FROM `stock` WHERE date = '" + date + "' AND wasteno = '" + wasteno + "' " + typCondition,
      }

      console.log(param.extension)

      // Daten -> Werden nur bei Insert oder Update gesendet
      var data = {
      }

      var result = await this.$func.queryAPI(param, data)

      console.log(result[0]["SUM(good_quantity_weight)"] || 0.00, result[0]["SUM(scrap_quantity_weight)"] || 0.00, result[0]["SUM(weight)"] || 0.00)

      // For steel (160117) and alu (160118), use weight instead of scrap_quantity_weight
      if(wasteno === '160117' || wasteno === '160118'){
        if(quantity_typ == "scrap"){
          return Number(result[0]["SUM(weight)"]).toFixed(2) || 0.00
        }
      }

      if(quantity_typ == "good"){
        return Number(result[0]["SUM(good_quantity_weight)"]).toFixed(2) || 0.00
      } else if(quantity_typ == "scrap"){
        return Number(result[0]["SUM(scrap_quantity_weight)"]).toFixed(2) || 0.00
      } else {
        return "0.00"
      }

    },

    async getDataForWeekReportDayTotal(date, typ){
      console.log("getDataForWeekReportDayTotal")

      // Build the typ condition - for 'sell', include both 'sell' and 'disposal'
      let typCondition = "";
      if (typ === 'sell') {
        typCondition = "(typ = 'sell' OR typ = 'disposal')";
      } else if (typ === 'buy') {
        typCondition = "typ = 'buy'";
      } else {
        typCondition = "typ = '" + typ + "'";
      }

      // Einstellungen
      var param = {
        table: "",            // Tabellen Name
        statement: "custom",  // SELECT, INSERT, UPDATE, DELETE, CUSTOM
        type: "detail",       // detail, list (Bei SELECT) --> "detail" erfordert id, listfilter
        where: "true",
        selector: "",         // bei listflter -> id,name,test
        value: "",
        short: "false",       // Übermittlung nur von id
        debug: "false",       // Debug Ausgabe bei Select Abfrage
        extension: "SELECT SUM(weight) FROM `stock` WHERE date = '" + date + "' AND " + typCondition
      }

      console.log(param.extension)

      // Daten -> Werden nur bei Insert oder Update gesendet
      var data = {}

      var result = await this.$func.queryAPI(param, data)

      console.log(result[0]["SUM(weight)"] || 0.00)
      return Number(result[0]["SUM(weight)"]).toFixed(2) || "0.00"
    },

    async getDataForWeekReportStockTotal(date){
      console.log("getDataForWeekReportStockTotal")

      const [day, month, year] = date.split('.').map(Number);

      const pad = n => n.toString().padStart(2, '0');

// Jahresanfang mit 23:50:00
      const yearStart = `${year}-01-01`;

// Datum aus `date` mit 23:50:00
      const currentFormatted = `${year}-${pad(month)}-${pad(day)}`;

      // Einstellungen
      var param = {
        table: "",            // Tabellen Name
        statement: "custom",  // SELECT, INSERT, UPDATE, DELETE, CUSTOM
        type: "detail",       // detail, list (Bei SELECT) --> "detail" erfordert id, listfilter
        where: "true",
        selector: "",         // bei listflter -> id,name,test
        value: "",
        short: "false",       // Übermittlung nur von id
        debug: "false",       // Debug Ausgabe bei Select Abfrage
        // filter: "false",   // Bei true wird ein Feld gefiltert
        // filterfield: "",
        // filtervalue: "",
        // operator: "AND",   // AND für filterlist LIKE abfrage ()
        // Filter noch hinzufügen
        extension: "SELECT SUM(weight) FROM `stock` WHERE date_timestamp >= '" + yearStart + "' AND date_timestamp <= '" + currentFormatted + "'" ,        // Erweiterung am Ende des SQL Befehls z.B. ORDER BY Colum ASC - Wird am Ende der SQL Abfrage hinzugefügt, bei CUSTOM entspricht das der gesamten Abfrage
      }

      // Daten -> Werden nur bei Insert oder Update gesendet
      var data = {
      }

      var result = await this.$func.queryAPI(param, data)

      console.log(result[0]["SUM(weight)"] || 0.00)
      return (Number(result[0]["SUM(weight)"]) + (parseFloat(this.exportStartValueGood) + parseFloat(this.exportStartValueScrapped) || 0)).toFixed(2);

    },

    // async getDataForWeekReportWeekTotal(start, end, wasteno, typ, quantity_typ){
    //   console.log("getDataForWeekReportDayTotal")

    //   var start_date = start.split('.').reverse().join('-');
    //   var end_date = end.split('.').reverse().join('-');
    //   let typCondition = "";
    //   if (typ === 'sell_disposal') {
    //     typCondition = "(typ = 'sell' OR typ = 'disposal')";
    //   } else if (typ === 'buy') {
    //     typCondition = "typ = 'buy'";
    //   } else {
    //     typCondition = "typ = '" + typ + "'";
    //   }

    //   // Einstellungen
    //   var param = {
    //     table: "",            // Tabellen Name
    //     statement: "custom",  // SELECT, INSERT, UPDATE, DELETE, CUSTOM
    //     type: "detail",       // detail, list (Bei SELECT) --> "detail" erfordert id, listfilter
    //     where: "true",
    //     selector: "",         // bei listflter -> id,name,test
    //     value: "",
    //     short: "false",       // Übermittlung nur von id
    //     debug: "false",       // Debug Ausgabe bei Select Abfrage
    //     // filter: "false",   // Bei true wird ein Feld gefiltert
    //     // filterfield: "",
    //     // filtervalue: "",
    //     // operator: "AND",   // AND für filterlist LIKE abfrage ()
    //     // Filter noch hinzufügen
    //     extension: "SELECT SUM(weight), SUM(good_quantity_weight), SUM(scrap_quantity_weight) FROM `stock` WHERE date_timestamp >= '" + start_date + "' AND date_timestamp <= '" + end_date + "' AND wasteno='" + wasteno + "' AND typ = '" + typCondition + "'" ,        // Erweiterung am Ende des SQL Befehls z.B. ORDER BY Colum ASC - Wird am Ende der SQL Abfrage hinzugefügt, bei CUSTOM entspricht das der gesamten Abfrage
    //   }


    //   if(wasteno == ""){
    //     param.extension = "SELECT SUM(weight), SUM(good_quantity_weight), SUM(scrap_quantity_weight) FROM `stock` WHERE date_timestamp >= '" + start_date + "' AND date_timestamp <= '" + end_date + "' AND typ = '" + typCondition + "'"
    //   }


    //   // datetime >= "01-01-2009 00:00:00" and datetime <= now()

    //   // Daten -> Werden nur bei Insert oder Update gesendet
    //   var data = {
    //   }

    //   var result = await this.$func.queryAPI(param, data)

    //   if (quantity_typ === "good") {
    //     return Number(result[0]["SUM(good_quantity_weight)"] ?? 0).toFixed(2);
    //   } else if (quantity_typ === "scrap") {
    //     return Number(result[0]["SUM(scrap_quantity_weight)"] ?? 0).toFixed(2);
    //   } else if (quantity_typ === "all") {
    //     return Number(result[0]["SUM(weight)"] ?? 0).toFixed(2);
    //   } else {
    //     return "0.00";
    //   }
    // },

    async getDataForWeekReportWeekTotal(start, end, wasteno, typ, quantity_typ){
      console.log("getDataForWeekReportWeekTotal", {start, end, wasteno, typ, quantity_typ})

      var start_date = start.split('.').reverse().join('-');
      var end_date = end.split('.').reverse().join('-');

      let typCondition = "";
      if (typ === 'sell_disposal') {
        // Include both sell AND disposal for outgoing totals
        typCondition = "(typ = 'sell' OR typ = 'disposal')";
      } else if (typ === 'buy') {
        typCondition = "typ = 'buy'";
      } else {
        typCondition = "typ = '" + typ + "'";
      }

      // Build the full WHERE clause
      let whereClause = "date_timestamp >= '" + start_date + "' AND date_timestamp <= '" + end_date + "' AND " + typCondition;
      
      // Only add wasteno filter if it's provided
      if(wasteno !== ""){
        whereClause += " AND wasteno='" + wasteno + "'";
      }

      // Einstellungen
      var param = {
        table: "",
        statement: "custom",
        type: "detail",
        where: "true",
        selector: "",
        value: "",
        short: "false",
        debug: "true", 
        extension: "SELECT SUM(weight) as total_weight, SUM(good_quantity_weight) as total_good, SUM(scrap_quantity_weight) as total_scrap FROM `stock` WHERE " + whereClause
      }

      console.log("Week total query:", param.extension)

      var data = {}
      
      try {
        var result = await this.$func.queryAPI(param, data)
        
        console.log("Week total result:", result)
        
        // Check if result is valid
        if (!result || result.length === 0) {
          console.warn("No results returned for week total query")
          return "0.00";
        }

        if (quantity_typ === "good") {
          return Number(result[0]["total_good"] ?? 0).toFixed(2);
        } else if (quantity_typ === "scrap") {
          return Number(result[0]["total_scrap"] ?? 0).toFixed(2);
        } else if (quantity_typ === "all") {
          return Number(result[0]["total_weight"] ?? 0).toFixed(2);
        } else {
          return "0.00";
        }
      } catch (error) {
        console.error("Error in getDataForWeekReportWeekTotal:", error);
        return "0.00";
      }
    },
    async getDataForWeekReportStock(date, wasteno, quantity_typ){
      console.log("getDataForWeekReportDay")

      const [day, month, year] = date.split('.').map(Number);

      const pad = n => n.toString().padStart(2, '0');

// Jahresanfang mit 23:50:00
      const yearStart = `${year}-01-01`;

// Datum aus `date` mit 23:50:00
      const currentFormatted = `${year}-${pad(month)}-${pad(day)}`;

      // Einstellungen
      var param = {
        table: "",            // Tabellen Name
        statement: "custom",  // SELECT, INSERT, UPDATE, DELETE, CUSTOM
        type: "detail",       // detail, list (Bei SELECT) --> "detail" erfordert id, listfilter
        where: "true",
        selector: "",         // bei listflter -> id,name,test
        value: "",
        short: "false",       // Übermittlung nur von id
        debug: "false",       // Debug Ausgabe bei Select Abfrage
        // filter: "false",   // Bei true wird ein Feld gefiltert
        // filterfield: "",
        // filtervalue: "",
        // operator: "AND",   // AND für filterlist LIKE abfrage ()
        // Filter noch hinzufügen
        extension: "SELECT SUM(good_quantity_weight), SUM(scrap_quantity_weight), SUM(weight) FROM `stock` WHERE date_timestamp >= '" + yearStart + "' AND date_timestamp <= '" + currentFormatted + "' AND wasteno = '" + wasteno + "'" ,        // Erweiterung am Ende des SQL Befehls z.B. ORDER BY Colum ASC - Wird am Ende der SQL Abfrage hinzugefügt, bei CUSTOM entspricht das der gesamten Abfrage
      }


      // Daten -> Werden nur bei Insert oder Update gesendet
      var data = {
      }

      var result = await this.$func.queryAPI(param, data)


      if (wasteno == '160118') {
        return (Number(result[0]["SUM(scrap_quantity_weight)"]) + (parseFloat(this.exportStartValueAlu) || 0))
            .toFixed(2);
      } else if (wasteno == '160117') {
        return (Number(result[0]["SUM(scrap_quantity_weight)"]) + (parseFloat(this.exportStartValueSteel) || 0))
            .toFixed(2);
      } else if (wasteno == '160103' && quantity_typ === "scrap") {
        return (Number(result[0]["SUM(scrap_quantity_weight)"]) + (parseFloat(this.exportStartValueScrapped) || 0))
            .toFixed(2);
      } else if (wasteno == '160103' && quantity_typ === "good") {
        return (Number(result[0]["SUM(good_quantity_weight)"]) + (parseFloat(this.exportStartValueGood) || 0))
            .toFixed(2);
      } else {
        return "0.00";
      }



    },

    async getChartData(){
      console.log("getChartData")

      var days = this.getISOWeekDates(this.ckw, this.cyear)

      this.kw_date_start = this.$moment(days[0], "YYYY-MM-DD").format("DD.MM.YYYY")
      this.kw_date_end = this.$moment(days[6], "YYYY-MM-DD").format("DD.MM.YYYY")

      // Einstellungen
      var param = {
        table: this.table,    // Tabellen Name
        statement: "custom",  // SELECT, INSERT, UPDATE, DELETE, CUSTOM
        type: "detail",       // detail, list (Bei SELECT) --> "detail" erfordert id, listfilter
        where: "true",
        selector: "",         // bei listflter -> id,name,test
        value: "",
        short: "false",       // Übermittlung nur von id
        debug: "false",       // Debug Ausgabe bei Select Abfrage
        // filter: "false",   // Bei true wird ein Feld gefiltert
        // filterfield: "",
        // filtervalue: "",
        // operator: "AND",   // AND für filterlist LIKE abfrage ()
        // Filter noch hinzufügen
        extension: "SELECT SUM(weight) FROM `stock` WHERE date_timestamp >= '" + days[0] + "' AND date_timestamp <= '" + days[6] + "'" ,        // Erweiterung am Ende des SQL Befehls z.B. ORDER BY Colum ASC - Wird am Ende der SQL Abfrage hinzugefügt, bei CUSTOM entspricht das der gesamten Abfrage
      }

      // console.log(param.extension)

      // datetime >= "01-01-2009 00:00:00" and datetime <= now()

      // Daten -> Werden nur bei Insert oder Update gesendet
      var data = {
      }

      var result = await this.$func.queryAPI(param, data)

      // console.log(result[0]["SUM(weight)"])
      // this.kw_sum = Number(result[0]["SUM(weight)"]).toFixed(3)
      // console.log(this.kw_sum)


      // Einstellungen
      param = {
        table: this.table,    // Tabellen Name
        statement: "custom",  // SELECT, INSERT, UPDATE, DELETE, CUSTOM
        type: "detail",       // detail, list (Bei SELECT) --> "detail" erfordert id, listfilter
        where: "true",
        selector: "",         // bei listflter -> id,name,test
        value: "",
        short: "false",       // Übermittlung nur von id
        debug: "false",       // Debug Ausgabe bei Select Abfrage
        // filter: "false",   // Bei true wird ein Feld gefiltert
        // filterfield: "",
        // filtervalue: "",
        // operator: "AND",   // AND für filterlist LIKE abfrage ()
        // Filter noch hinzufügen
        extension: "SELECT SUM(weight) FROM `stock` WHERE date_timestamp >= '2009-01-01' AND date_timestamp <= '" + days[6] + "'" ,        // Erweiterung am Ende des SQL Befehls z.B. ORDER BY Colum ASC - Wird am Ende der SQL Abfrage hinzugefügt, bei CUSTOM entspricht das der gesamten Abfrage
      }

      // console.log(param.extension)

      // datetime >= "01-01-2009 00:00:00" and datetime <= now()

      // Daten -> Werden nur bei Insert oder Update gesendet
      data = {
      }

      result = await this.$func.queryAPI(param, data)

      // console.log(result[0]["SUM(weight)"])
      this.kw_total = Number(result[0]["SUM(weight)"]).toFixed(3)

      this.kw_total_qty = Math.round(((result[0]["SUM(weight)"] * 1000).toFixed(3) * this.average_weight)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")


      // 'KW 1 / 2022: <b>0 Tonnen</b>'

      this.kw_text = "KW " + this.ckw + " / " + this.cyear + "<br> " + this.kw_date_start + " - " + this.kw_date_end + " <br><b> Gesamt: " + this.kw_total + " Tonnen</b><br> Zugang/Abgang: " // + this.kw_sum + " Tonnen"

    },

    /*
    Calculates the total weight for the selected date
     */
    async calcTotalWeight(){
      console.log("calcTotalWeight")
      // const currentYear = new Date().getFullYear()


      const currentYear = this.$moment(this.date, "DD.MM.YYYY").format("YYYY")
      this.selected_year = currentYear

      const selected_year_first = this.selected_year + "-01-01"
      // this.startDate = `${currentYear}-01-01`

      await this.loadStockInventur(this.selected_year)

      // get Alu
      var param = {
        table: this.table,    // Tabellen Name
        statement: "custom",  // SELECT, INSERT, UPDATE, DELETE, CUSTOM
        type: "detail",       // detail, list (Bei SELECT) --> "detail" erfordert id, listfilter
        where: "true",
        selector: "",         // bei listflter -> id,name,test
        value: "",
        short: "false",       // Übermittlung nur von id
        debug: "false",
        extension: "SELECT SUM(scrap_quantity_weight) FROM `stock` WHERE wasteno='160118' AND date_timestamp >= '" + selected_year_first + "' AND date_timestamp <= '" + this.$moment(this.date, "DD.MM.YYYY").format("YYYY-MM-DD") + "'" ,
      }

      var data = {
      }

      console.log("param.extension")
      console.log(param.extension)

      var result = await this.$func.queryAPI(param, data)

      this.total_weight_160118 = Number(result[0]["SUM(scrap_quantity_weight)"]).toFixed(3)


      // get Tyres (160103)
       param = {
        table: this.table,    // Tabellen Name
        statement: "custom",  // SELECT, INSERT, UPDATE, DELETE, CUSTOM
        type: "detail",       // detail, list (Bei SELECT) --> "detail" erfordert id, listfilter
        where: "true",
        selector: "",         // bei listflter -> id,name,test
        value: "",
        short: "false",       // Übermittlung nur von id
        debug: "false",       // Debug Ausgabe bei Select Abfrage
        extension: "SELECT SUM(weight), SUM(scrap_quantity_weight), SUM(good_quantity_weight) FROM `stock` WHERE wasteno='160103' AND date_timestamp >= '" + selected_year_first + "' AND date_timestamp <= '" + this.$moment(this.date, "DD.MM.YYYY").format("YYYY-MM-DD") + "'" ,
      }

      data = {
      }

      result = await this.$func.queryAPI(param, data)

      console.log("param.extension")
      console.log(param.extension)

      this.total_weight_160103 = Number(result[0]["SUM(scrap_quantity_weight)"]).toFixed(3)
      this.total_weight_160103_good = Number(result[0]["SUM(good_quantity_weight)"]).toFixed(3)



      // get Steel (160117)
      param = {
        table: this.table,    // Tabellen Name
        statement: "custom",  // SELECT, INSERT, UPDATE, DELETE, CUSTOM
        type: "detail",       // detail, list (Bei SELECT) --> "detail" erfordert id, listfilter
        where: "true",
        selector: "",         // bei listflter -> id,name,test
        value: "",
        short: "false",       // Übermittlung nur von id
        debug: "false",       // Debug Ausgabe bei Select Abfrage
        extension: "SELECT SUM(scrap_quantity_weight) FROM `stock` WHERE wasteno='160117' AND date_timestamp >= '" + selected_year_first + "' AND date_timestamp <= '" + this.$moment(this.date, "DD.MM.YYYY").format("YYYY-MM-DD") + "'" ,        // Erweiterung am Ende des SQL Befehls z.B. ORDER BY Colum ASC - Wird am Ende der SQL Abfrage hinzugefügt, bei CUSTOM entspricht das der gesamten Abfrage
      }

      data = {
      }

      result = await this.$func.queryAPI(param, data)

      this.total_weight_160117 = Number(result[0]["SUM(scrap_quantity_weight)"]).toFixed(3)

      this.total_weight_160118 = (parseFloat(this.total_weight_160118) || 0) + (parseFloat(this.exportStartValueAlu) || 0)
      this.total_weight_160117 = (parseFloat(this.total_weight_160117) || 0) + (parseFloat(this.exportStartValueSteel) || 0)
      this.total_weight_160103 = (parseFloat(this.total_weight_160103) || 0) + (parseFloat(this.exportStartValueScrapped) || 0)
      this.total_weight_160103_good = (parseFloat(this.total_weight_160103_good) || 0) + (parseFloat(this.exportStartValueGood) || 0)

      this.total_weight_160118 = this.total_weight_160118.toFixed(3)
      this.total_weight_160117 = this.total_weight_160117.toFixed(3)
      this.total_weight_160103 = this.total_weight_160103.toFixed(3)
      this.total_weight_160103_good = this.total_weight_160103_good.toFixed(3)



    },

    async setReportDays(day, i){

      var zugang = 0
      var abgang = 0
      var saldo = 0

      // Einstellungen
      var param = {
        table: this.table,    // Tabellen Name
        statement: "custom",  // SELECT, INSERT, UPDATE, DELETE, CUSTOM
        type: "detail",       // detail, list (Bei SELECT) --> "detail" erfordert id, listfilter
        where: "true",
        selector: "",         // bei listflter -> id,name,test
        value: "",
        short: "false",       // Übermittlung nur von id
        debug: "false",       // Debug Ausgabe bei Select Abfrage
        // filter: "false",   // Bei true wird ein Feld gefiltert
        // filterfield: "",
        // filtervalue: "",
        // operator: "AND",   // AND für filterlist LIKE abfrage ()
        // Filter noch hinzufügen
        extension: "SELECT SUM(weight) FROM `stock` WHERE date= '" + day + "' AND typ = 'buy'" ,        // Erweiterung am Ende des SQL Befehls z.B. ORDER BY Colum ASC - Wird am Ende der SQL Abfrage hinzugefügt, bei CUSTOM entspricht das der gesamten Abfrage
      }

      // console.log(param.extension)

      // datetime >= "01-01-2009 00:00:00" and datetime <= now()

      // Daten -> Werden nur bei Insert oder Update gesendet
      var data = {
      }

      var result = await this.$func.queryAPI(param, data)

      console.log(result)
      zugang = Number(result[0]["SUM(weight)"]).toFixed(3)





      // Einstellungen
       param = {
        table: this.table,    // Tabellen Name
        statement: "custom",  // SELECT, INSERT, UPDATE, DELETE, CUSTOM
        type: "detail",       // detail, list (Bei SELECT) --> "detail" erfordert id, listfilter
        where: "true",
        selector: "",         // bei listflter -> id,name,test
        value: "",
        short: "false",       // Übermittlung nur von id
        debug: "false",       // Debug Ausgabe bei Select Abfrage
        // filter: "false",   // Bei true wird ein Feld gefiltert
        // filterfield: "",
        // filtervalue: "",
        // operator: "AND",   // AND für filterlist LIKE abfrage ()
        // Filter noch hinzufügen
        extension: "SELECT SUM(weight) FROM `stock` WHERE date= '" + day + "' AND (typ = 'sell' OR typ = 'disposal')" ,        // Erweiterung am Ende des SQL Befehls z.B. ORDER BY Colum ASC - Wird am Ende der SQL Abfrage hinzugefügt, bei CUSTOM entspricht das der gesamten Abfrage
      }

      // console.log(param.extension)

      // datetime >= "01-01-2009 00:00:00" and datetime <= now()

      // Daten -> Werden nur bei Insert oder Update gesendet
       data = {
      }

       result = await this.$func.queryAPI(param, data)

       abgang = Number(result[0]["SUM(weight)"]).toFixed(3)




        saldo = (Number(zugang) - Math.abs(abgang))

        saldo = Number(saldo).toFixed(3)


      switch (i){

        case 0:
          this.report_mo = "Mo. " + day + "            " +zugang + "                        " + abgang + "                        " + saldo
        break;
        case 1:
          this.report_di = "Di. " + day + "            " +zugang + "                        " + abgang + "                        " + saldo
          break;
        case 2:
          this.report_mi = "Mi. " + day + "            " +zugang + "                        " + abgang + "                        " + saldo
          break;
        case 3:
          this.report_do = "Do. " + day + "            " +zugang + "                        " + abgang + "                        " + saldo
          break;
        case 4:
          this.report_fr = "Fr. " + day + "            " +zugang + "                        " + abgang + "                        " + saldo
          break;
        case 5:
          this.report_sa = "Sa. " + day + "            " +zugang + "                        " + abgang + "                        " + saldo
          break;
        case 6:
          this.report_so = "So. " + day + "            " +zugang + "                        " + abgang + "                        " + saldo
          break;

      }


    },

    async reloadTotalWeight(){

      await this.calcTotalWeight()

    },

    async filterReset(){


      this.extension = ""
      this.filter_date = ""
      this.filter_wasteno_selected = ""
      this.filter_article_selected = ""
      this.filter_typ_selected = ""



      // Remove MyComponent from the DOM
      this.renderComponent = false;

      // Wait for the change to get flushed to the DOM
      await this.$nextTick();

      // Add the component back in
      this.renderComponent = true;

    },

    async loadDataFilter(){

      // console.log("this.filter_date")
      // console.log(this.filter_date)

      if(this.filter_date == "" && this.filter_wasteno_selected == "" && this.filter_article_selected == "" && this.filter_typ_selected == ""){
        this.extension = ""
      }else{
        this.extension = "date LIKE '%" + this.filter_date + "%' AND typ LIKE '%" + this.filter_typ_selected + "%' AND article_name LIKE '%" + this.filter_article_selected + "%' AND wasteno LIKE '%" + this.filter_wasteno_selected + "%'"

      }



      // Remove MyComponent from the DOM
      this.renderComponent = false;

      // Wait for the change to get flushed to the DOM
      await this.$nextTick();

      // Add the component back in
      this.renderComponent = true;



    },

    async loadData() {
      console.log("loadData")

      // Einstellungen
      var param = {
        table: "parameter",
        statement: "select",
        type: "detail",
        where: "true",
        selector: "schluessel",
        value: "average_weight",
        short: "true", // Übermittlung nur von id
        // filter: "false",
        // filterfield: "",
        // filtervalue: "",
        // operator: "true",
        // Filter noch hinzufügen
        extension: "",
      }

      // Daten -> Werden nur bei Insert oder Update gesendet
      var data = {}

      var result = await this.$func.queryAPI(param, data)

      console.log(result)

      if(result.lenght == 0){
        this.average_weight = ""
        return
      }

      this.average_weight = result[0]["wert"]

    },

    // Ermittelt die Tage einer Kalenderwoche Mo-So.
     getISOWeekDates(isoWeekNum = 1, year = new Date().getFullYear()) {
    let d = this.$moment(String(year).padStart(4, '0') + 'W' +
      String(isoWeekNum).padStart(2,'0'));
    for (var dates=[], i=0; i < 7; i++) {
    //dates.push(d.format('ddd DD MMM YYYY'));
    dates.push(d.format('YYYY-MM-DD'));
    d.add(1, 'day');
    }
      return dates;
    }


  },

  watch: {

    filter_select(){
      console.log("this.filter_select: " + this.filter_select)
    },



    date(){

      console.log("this.date: " + this.date)
      // Reload Data total Values from
      this.reloadTotalWeight()
    },

    startDate(){
      console.log("this.startDate: " + this.startDate + " - " + this.endDate)


      if (endDate != "") {
        if (this.$moment(this.startDate, "DD.MM.YYYY").format("YYYY") != this.$moment(this.endDate, "DD.MM.YYYY").format("YYYY")) {
          alert("Start und Enddatum müssen im gleichen Jahr liegen.")
          this.startDate = ""
          this.endDate = ""
          return
        }else{
          this.loadStockInventur(this.$moment(this.startDate, "DD.MM.YYYY").format("YYYY"))
        }

      }


    },

    endDate(){
      console.log("this.endDate: " + this.startDate + " - " + this.endDate)

      if (this.startDate != "") {
        if (this.$moment(this.startDate, "DD.MM.YYYY").format("YYYY") != this.$moment(this.endDate, "DD.MM.YYYY").format("YYYY")) {
          alert("Start und Enddatum müssen im gleichen Jahr liegen.")
          this.endDate = ""
          this.startDate = ""
          return
        }else{
          this.loadStockInventur(this.$moment(this.startDate, "DD.MM.YYYY").format("YYYY"))
        }
      }
    },


    cyear(){
    }



  },


  computed: {
    headers () {
      return [
        { text: 'Datum', align: 'start', sortable: true, value: 'date_timestamp' },
        { text: 'Zeit', align: 'start', sortable: true, value: 'time' },
        { text: 'Typ', value: 'typ' },
        { text: 'Name', value: 'name' },
        { text: 'Artikel', value: 'article_name' },
        { text: 'Abfallschl.', value: 'wasteno' },
        { text: 'Bemerkungen', value: 'note' },
        { text: 'Gewicht in T', value: 'weight' },
        { text: 'Schrottanteil in T', value: 'scrap_quantity_weight' },
        { text: 'Gutanteil in T', value: 'good_quantity_weight' },
        { text: 'Mitarbeiter', value: 'worker' },
       // { text: 'Saldo', value: 'saldo' },
        { text: '', value: 'edit' },
      ]
    },
  },


}
</script>

<style scoped>

</style>
